<template>
  <main id="create-quote-page" class="page-container">
    <button type="button" class="back-btn" @click="goBack">
      <i class="fa-solid fa-arrow-left"></i> Indietro
    </button>
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Modale DUPLICATO preventivo -->
    <VueFinalModal
      v-model="showDuplicateModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content dup-modal__content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="closeDuplicateModal">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">
          {{
            lastDuplicateQuoteInfo?.isOrder
              ? "Ordine già presente"
              : "Preventivo già presente"
          }}
        </h3>

        <p class="dup-modal__intro">
          Esiste già
          {{ lastDuplicateQuoteInfo?.isOrder ? "un ordine" : "un preventivo" }}
          per questo cliente allo stesso indirizzo
          <span
            v-if="lastDuplicateQuoteInfo?.address"
            class="dup-modal__address"
          >
            ({{ lastDuplicateQuoteInfo.address }}) </span
          >.
        </p>

        <!-- Stato: loading -->
        <div v-if="dupLoading" class="dup-modal__skeleton">
          Caricamento in corso…
        </div>

        <!-- Stato: errore -->
        <div v-else-if="dupError" class="dup-modal__error">
          {{ dupError }}
        </div>

        <!-- Stato: dati -->
        <div v-else-if="dupQuote" class="dup-quote">
          <div class="dup-quote__grid">
            <div>
              <div class="dup-quote__label">ID</div>
              <div class="dup-quote__value">#{{ dupQuote.id }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Data</div>
              <div class="dup-quote__value">
                {{ formatToLocalDate(dupQuote.date) }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Cliente</div>
              <div class="dup-quote__value">
                {{ dupQuote.clientName || "—" }}
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Pagamento</div>
              <div class="dup-quote__value">{{ dupQuote.payment_method }}</div>
            </div>
            <div>
              <div class="dup-quote__label">Indirizzo</div>
              <div class="dup-quote__value">
                <a
                  v-if="dupQuote.location?.link"
                  :href="dupQuote.location.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="custom-link"
                >
                  {{ dupQuote.location?.address || "Vedi mappa" }}
                </a>
                <span v-else>{{ dupQuote.location?.address || "—" }}</span>
              </div>
            </div>
            <div>
              <div class="dup-quote__label">Totale</div>
              <div class="dup-quote__value">
                {{ money(dupQuote.totalPrice) }}
              </div>
            </div>
          </div>

          <div class="dup-quote__items">
            <div class="dup-quote__items-head">
              <strong>Riepilogo articoli</strong>
              <span class="muted">({{ dupQuote.items?.length || 0 }})</span>
            </div>
            <ul class="dup-quote__items-list">
              <li
                v-for="(it, idx) in dupQuote.items || []"
                :key="idx"
                class="dup-item"
              >
                <div class="dup-item__name">
                  {{ it.itemName || it.brand || "Articolo" }}
                </div>
                <div class="dup-item__meta">
                  <span v-if="it.category" class="chip">{{ it.category }}</span>
                  <span v-if="it.boxQuantity"
                    >scatole: {{ it.boxQuantity }}</span
                  >
                  <span v-if="it.pieces">pezzi: {{ it.pieces }}</span>
                  <span v-if="it.iva !== undefined">IVA: {{ it.iva }}%</span>
                  <span v-if="it.price !== undefined"
                    >€ {{ number(it.price) }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="dup-modal__footer">
          <!-- Apri file (si vede solo se ho caricato docs) -->
          <button
            v-if="dupQuote && !dupLoading && dupDocuments.length"
            class="btn-primary"
            @click="showDupDocs = true"
          >
            Apri file
          </button>
          <!-- <router-link
            v-if="lastDuplicateQuoteInfo?.quoteId"
            class="btn primary"
            :to="`/quote/${lastDuplicateQuoteInfo.quoteId}`"
            @click="onViewedExisting"
          >
            Apri preventivo esistente
          </router-link> -->

          <!-- [sc-48258] Solo creando un ordine: la vendita non si ferma per un
               preventivo aperto allo stesso indirizzo. -->
          <button
            v-if="asOrder"
            class="btn-primary"
            @click="creaOrdineNonostanteDuplicato"
          >
            Crea comunque l'ordine
          </button>

          <button class="btn-primary" @click="onChangeAddress">
            Usa indirizzo diverso
          </button>

          <button
            class="btn-ghost"
            :disabled="!lastDuplicateQuoteInfo?.quoteId"
            @click="onDuplicateWithEdit"
          >
            Duplica modificando indirizzo
          </button>
        </div>

        <!-- DEV: riquadro debug, rimuovi quando hai finito -->
        <!-- <div
          v-if="showDuplicateModal"
          style="margin-top: 12px; font-size: 12px; color: #555"
        >
          <details>
            <summary>Debug dup</summary>
            <pre style="white-space: pre-wrap; word-break: break-word">
lastDuplicateQuoteInfo: {{ lastDuplicateQuoteInfo }}
dupLoading: {{ dupLoading }}
dupError: {{ dupError }}
dupQuote: {{ dupQuote }}
    </pre
            >
          </details>
        </div> -->
      </template>
    </VueFinalModal>

    <VueFinalModal
      v-model="showDupDocs"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="documents-modal-content"
    >
      <template #default>
        <button class="modal__close icons-button" @click="showDupDocs = false">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Preventivo #{{ dupQuote?.id }}</h3>

        <div class="documents-grid">
          <div v-for="doc in dupDocuments" :key="doc.id" class="document-card">
            <a href="#" class="card-link" @click.prevent="openDoc(doc)">
              <div class="card-icon-pdf">
                <i class="fa-solid fa-file-pdf"></i>
              </div>
              <div class="card-body">
                <div class="card-title">{{ formatDocName(doc.name) }}</div>
                <div class="card-subtitle">
                  Data di creazione: {{ formatToLocalDate(doc.createdAt) }}
                </div>
              </div>
            </a>
          </div>

          <div v-if="dupDocuments.length === 0" class="no-result">
            Nessun documento trovato
          </div>
        </div>
      </template>
    </VueFinalModal>

    <div class="create-quote-wrapper">
      <div class="create-quote-main-col" ref="mainCol">
        <!-- Form principale -->
        <form
          class="create-quote-form"
          @submit.prevent="onCreateQuoteAndGeneratePdf"
        >
          <!-- SEZIONE: Anagrafica preventivo -->
          <section class="quote-section">
            <h3 class="quote-section__title">
              <i class="fa-solid fa-file-lines"></i>
              {{ asOrder ? "Anagrafica ordine" : "Anagrafica preventivo" }}
            </h3>
            <div class="quote-section__grid">
              <!-- Colonna 1: Cliente + Modalità di pagamento -->
              <div class="quote-section__col">
                <!-- Seleziona Cliente -->
                <div class="field" id="client-select">
                  <label>Cliente</label>
                  <SearchableCombo
                    v-model="formData.clientId"
                    :items="comboClients"
                    :labelKey="
                      (c) =>
                        c.email
                          ? `${c.clientName} - (${c.email})`
                          : c.pec
                          ? `${c.clientName} - (${c.pec})`
                          : c.clientName
                    "
                    :valueKey="(c) => c.id"
                    placeholder="Cerca cliente..."
                    :loading="clientsLoading"
                    emptyText="Nessun risultato"
                    @search="onSearchClient"
                    @select="selectClient"
                  />
                </div>

                <!-- Modalità di pagamento -->
                <div class="field">
                  <label for="payment-method">Modalità di pagamento</label>
                  <StatusSelect
                    v-model="formData.payment_method"
                    :options="paymentOptions"
                    placeholder="Seleziona metodo..."
                    placeholderIcon="fa-wallet"
                  />
                </div>

                <!-- [sc-48258] Pagato: sta accanto al metodo di pagamento
                     perché è lo stesso discorso — se è pagato, è pagato con
                     quel metodo. Solo creando un ordine. -->
                <div v-if="asOrder" class="field">
                  <label class="scelta-si-no__titolo">Pagato</label>
                  <div class="scelta-si-no">
                    <label class="scelta-si-no__opzione">
                      <input
                        type="radio"
                        :value="false"
                        v-model="ordineSaldato"
                      />
                      No
                    </label>
                    <label class="scelta-si-no__opzione">
                      <input
                        type="radio"
                        :value="true"
                        v-model="ordineSaldato"
                      />
                      Sì
                    </label>
                  </div>
                  <p class="field-hint">
                    L'incasso viene registrato col metodo di pagamento scelto.
                  </p>
                </div>
              </div>

              <!-- Colonna 2: Data + Indirizzo -->
              <div class="quote-section__col">
                <!-- Data Preventivo -->
                <div class="field">
                  <label for="date">Data</label>
                  <FlatPickr
                    id="date"
                    v-model="formData.date"
                    :config="dateConfig"
                    placeholder="gg/mm/aaaa"
                  />
                </div>

                <!-- Indirizzo: sempre visibile; readonly + nota "Ritiro in sede" quando non è consegna -->
                <div class="field">
                  <label for="address">Indirizzo di consegna</label>
                  <input
                    type="text"
                    id="address"
                    v-model="addressModel"
                    :readonly="formData.deliveryType !== 'consegna'"
                    :class="{
                      'readonly-field': formData.deliveryType !== 'consegna',
                    }"
                    placeholder="Inserisci indirizzo completo…"
                    autocomplete="off"
                  />
                </div>
              </div>

              <!-- Colonna 3: Modalità di consegna -->
              <div class="quote-section__col">
                <div class="field">
                  <label>
                    Modalità di consegna <span class="required-mark">*</span>
                  </label>
                  <StatusSelect
                    v-model="deliveryTypeModel"
                    :options="deliveryOptions"
                    placeholder="Seleziona modalità..."
                    placeholderIcon="fa-truck"
                  />
                </div>

                <!-- [sc-48258] Merce consegnata: sotto la modalità di
                     consegna, perché è la stessa decisione. Solo creando un
                     ordine, e solo se è pagato: il server rifiuta un ordine
                     consegnato e non saldato. -->
                <div v-if="asOrder" class="field">
                  <label class="scelta-si-no__titolo">Merce consegnata</label>
                  <div
                    class="scelta-si-no"
                    :class="{ 'scelta-si-no--off': !ordineSaldato }"
                  >
                    <label class="scelta-si-no__opzione">
                      <input
                        type="radio"
                        :value="false"
                        v-model="ordineConsegnato"
                        :disabled="!ordineSaldato"
                      />
                      No
                    </label>
                    <label class="scelta-si-no__opzione">
                      <input
                        type="radio"
                        :value="true"
                        v-model="ordineConsegnato"
                        :disabled="!ordineSaldato"
                      />
                      Sì
                    </label>
                  </div>
                  <p class="field-hint">
                    {{ notaConsegna }}
                  </p>
                </div>
              </div>
            </div>
          </section>

          <!-- RIGA: form articolo (40%) + articoli aggiunti (60%) -->
          <div class="quote-work-row">
            <!-- Colonna sinistra (40%): form articolo + note e addebiti -->
            <div class="quote-work-col">
              <!-- SEZIONE: Articolo (form) -->
              <section class="quote-section">
                <h3 class="quote-section__title">
                  <i class="fa-solid fa-cart-shopping"></i> Articolo
                </h3>
                <div class="quote-section__col">
                  <!-- RIGA 3: scegli articolo, quantità -->
                  <div class="create-quote-row row-3">
                    <!-- scegli Articolo -->
                    <div class="field" id="item-select">
                      <label for="item-search">Articolo</label>
                      <SearchableCombo
                        v-model="newItem.itemId"
                        v-model:text="searchQueryItem"
                        :items="filteredItems"
                        :labelKey="itemSearchLabel"
                        :valueKey="(it) => it.id"
                        placeholder="Cerca articolo..."
                        :disabled="false"
                        :loading="itemsLoading"
                        :current-page="itemsPage"
                        :requested-page="itemsRequestedPage"
                        :total-pages="itemsTotalPages"
                        :total-items="itemsTotalItems"
                        :total-is-capped="itemsTotalIsCapped"
                        :show-pagination="true"
                        emptyText="Nessun risultato"
                        @search="onSearchItem"
                        @select="selectItem"
                        @page-change="onItemPageChange"
                        @cleared="clearItemSelection"
                      >
                        <template #option="{ option }">
                          <span class="quote-item-option">
                            <span class="quote-item-option__content">
                              <span
                                class="quote-item-option__label"
                                :class="{
                                  'is-out': isOrderableOutOfStock(option),
                                }"
                              >
                                <span v-if="isOrderableOutOfStock(option)"
                                  >! </span
                                >{{ itemSearchLabel(option) }}
                              </span>
                              <span
                                v-if="itemFormatFinish(option)"
                                class="quote-item-option__meta"
                              >
                                {{ itemFormatFinish(option) }}
                              </span>
                            </span>
                            <span
                              class="quote-item-option__stock"
                              :class="{
                                'in-stock': warehouseCount(option) > 0,
                              }"
                              :title="stockTitle(option)"
                            >
                              {{ stockLabel(option) }}
                            </span>
                          </span>
                        </template>
                      </SearchableCombo>
                      <p class="create-item-cta">
                        Articolo non trovato?
                        <button
                          type="button"
                          class="create-item-link"
                          @click.prevent.stop="openCreateItemModal"
                        >
                          <i class="fa-solid fa-circle-plus"></i> Crea articolo
                        </button>
                      </p>
                    </div>

                    <!-- Quantità a pezzi: solo per articoli non venduti a scatola -->
                    <div class="field" v-if="!showMqField">
                      <label :for="'quantity'">{{ quantityLabel }}</label>
                      <input
                        id="quantity"
                        type="number"
                        min="1"
                        step="1"
                        v-model="quantityInput"
                        placeholder="Inserisci quantità"
                      />
                    </div>
                    <!-- Articoli a mq/ml: si scrivono i mq e basta. Le scatole intere
                         necessarie sono derivate dietro le quinte e mostrate nell'hint. -->
                    <div class="field" v-else>
                      <label for="mq-per-box">{{ mqFieldLabel }}</label>
                      <input
                        id="mq-per-box"
                        type="number"
                        min="0"
                        step="any"
                        v-model="mqInput"
                        placeholder="Inserisci i mq"
                      />
                      <!-- Dati scatola incompleti: l'articolo si può comunque
                           preventivare, ma la scheda va completata prima di
                           confermare il preventivo al cliente. -->
                      <small
                        v-if="missingBoxDataInfo"
                        class="field-warning"
                        role="alert"
                      >
                        {{ missingBoxDataInfo.text }}
                        <router-link
                          :to="missingBoxDataInfo.route"
                          target="_blank"
                          class="field-warning-link"
                          >Completa la scheda articolo</router-link
                        >
                      </small>
                      <small v-if="mqSummary" class="field-hint">{{
                        mqSummary
                      }}</small>
                    </div>
                  </div>
                  <!-- Flusso prezzo (IVA esclusa): listino → scontato → IVA -->
                  <div class="create-quote-row row-4 price-flow">
                    <!-- 1) Prezzo di listino NETTO (IVA esclusa), readonly -->
                    <div class="field">
                      <label for="price">Prezzo listino — IVA esclusa</label>
                      <input
                        id="price"
                        type="number"
                        v-model="newItem.price"
                        placeholder="Seleziona l'articolo per visualizzare il prezzo corrispondente"
                        step="0.01"
                        readonly
                        class="readonly-field"
                      />
                    </div>
                    <i
                      class="fa-solid fa-arrow-right price-flow__arrow"
                      aria-hidden="true"
                    ></i>
                    <!-- 2) Prezzo scontato NETTO (opzionale): prezzo netto da
                 applicare, digitato dall'operatore. Vuoto → usa il listino. -->
                    <div class="field">
                      <label for="discounted-price">Prezzo scontato</label>
                      <input
                        id="discounted-price"
                        type="number"
                        v-model="newItem.discountedPrice"
                        placeholder="Prezzo netto scontato (opzionale)"
                        step="0.01"
                        min="0"
                      />
                    </div>
                    <i
                      class="fa-solid fa-arrow-right price-flow__arrow"
                      aria-hidden="true"
                    ></i>
                    <!-- 3) IVA applicata alla riga (default 0%) -->
                    <div class="field">
                      <label for="vat-rate">IVA</label>
                      <StatusSelect
                        v-model="newItem.iva"
                        :options="ivaOptions"
                        placeholderIcon="fa-percent"
                      />
                    </div>
                  </div>

                  <!-- Anteprima riga: imponibile → imposta → totale (IVA esclusa
                       → ivato). Solo preview, non input. -->
                  <div class="create-quote-row line-preview">
                    <span class="line-preview__item"
                      >Imponibile:
                      <strong>€ {{ previewFormatted.taxable }}</strong></span
                    >
                    <span class="line-preview__item"
                      >Aliquota: <strong>{{ newItem.iva }}%</strong></span
                    >
                    <span class="line-preview__item"
                      >Imposta:
                      <strong>€ {{ previewFormatted.tax }}</strong></span
                    >
                    <span class="line-preview__item line-preview__total"
                      >Totale:
                      <strong>€ {{ previewFormatted.gross }}</strong></span
                    >
                  </div>

                  <!-- RIGA 3: bottone "+ aggiungi articolo" + "Mostra articoli" -->
                  <div class="create-quote-row row-5">
                    <!-- Bottone per aggiungere un ulteriore alla lista -->
                    <div class="field">
                      <button
                        type="button"
                        class="add-item-btn"
                        :disabled="!canAddItem"
                        @click="addItem"
                      >
                        <!-- icona -->
                        <i class="fa-solid fa-plus icon" aria-hidden="true"></i>
                        <span>aggiungi articolo</span>
                      </button>
                    </div>
                  </div>
                </div>
              </section>

              <!-- SEZIONE: Note e addebiti (sotto il form articolo) -->
              <section class="quote-section">
                <h3 class="quote-section__title">
                  <i class="fa-solid fa-note-sticky"></i> Note e addebiti
                </h3>
                <!-- RIGA 6: note + cambio lingua -->
                <div class="create-quote-row row-5 notes-row">
                  <!-- Richieste tecniche -->
                  <div class="field">
                    <label for="technical-requests">Note</label>
                    <textarea
                      id="technical-requests"
                      v-model.trim="formData.technical_queries"
                      placeholder="Inserisci note"
                      maxlength="2000"
                      rows="3"
                    ></textarea>
                  </div>
                </div>

                <!-- RIGA 7: Addebiti -->
                <div class="create-quote-row addebiti-row">
                  <div class="field">
                    <label>Addebiti</label>
                    <hr />
                    <div class="addebiti-line">
                      <span class="addebiti-label">Spesa imballo (€30,00)</span>
                      <label class="addebiti-option">
                        <input
                          type="radio"
                          :value="false"
                          v-model="formData.hasPackagingFee"
                        />
                        No
                      </label>
                      <label class="addebiti-option">
                        <input
                          type="radio"
                          :value="true"
                          v-model="formData.hasPackagingFee"
                        />
                        Sì
                      </label>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <!-- /.quote-work-col -->

            <!-- Colonna destra (60%): articoli aggiunti + salva -->
            <div class="quote-work-col">
              <!-- Articoli aggiunti -->
              <aside class="items-panel" ref="itemsPanel">
                <div class="items-panel__title-bar">
                  <h3 class="items-panel__title">Articoli aggiunti</h3>
                  <!-- [sc-48248] Suddivisioni del preventivo ("Bagno 2") -->
                  <button
                    type="button"
                    class="section-add-btn"
                    @click="apriNuovaSuddivisione"
                    title="Aggiungi una suddivisione al preventivo"
                  >
                    <i class="fa-solid fa-layer-group"></i>
                    Suddivisione
                  </button>
                </div>
                <div v-if="nuovaSuddivisioneAperta" class="section-new-bar">
                  <input
                    v-model="nuovaSuddivisioneNome"
                    type="text"
                    maxlength="100"
                    class="section-new-input"
                    placeholder="Nome della suddivisione — es. Bagno 2"
                    @keyup.enter="confermaNuovaSuddivisione"
                    @keyup.esc="annullaNuovaSuddivisione"
                  />
                  <button
                    type="button"
                    class="primary-btn section-new-confirm"
                    @click="confermaNuovaSuddivisione"
                  >
                    Aggiungi
                  </button>
                  <button
                    type="button"
                    class="secondary-btn"
                    @click="annullaNuovaSuddivisione"
                  >
                    Annulla
                  </button>
                </div>
                <div class="items-panel__table-wrap">
                  <table class="items-panel__table">
                    <thead>
                      <tr>
                        <!-- [sc-48248] colonna della maniglia di trascinamento -->
                        <th class="drag-handle-col"></th>
                        <th>Codice</th>
                        <th>Articolo</th>
                        <th>Categoria</th>
                        <th>Quantità</th>
                        <th>Prezzo</th>
                        <!-- [sc-49019] Totale di riga, IVA esclusa come il prezzo
                             accanto: il conto si rifà a occhio. -->
                        <th
                          class="row-total-head"
                          title="Prezzo × quantità, IVA esclusa"
                        >
                          Totale
                        </th>
                        <th>IVA</th>
                        <th></th>
                      </tr>
                    </thead>
                    <!-- [sc-48248] Un <tbody> per suddivisione: l'intestazione
                         sta in un tbody suo, le righe in uno trascinabile. Più
                         <tbody> nella stessa tabella sono HTML valido, ed è
                         l'unico modo di dare a Sortable un contenitore per
                         lista senza rinunciare alle intestazioni. -->
                    <template
                      v-for="gruppo in gruppiArticoli"
                      :key="`grp-${gruppo.nome || '__nessuna__'}`"
                    >
                      <tbody v-if="gruppo.nome">
                        <tr class="section-header-row">
                          <td colspan="9">
                            <template
                              v-if="rinominaSuddivisione === gruppo.nome"
                            >
                              <!-- [sc-48248] Rinomina: stessa barra della riga normale, campo
                                   della larghezza del nome e due icone piccole. -->
                              <span class="section-header-bar">
                                <i class="fa-solid fa-layer-group"></i>
                                <input
                                  v-model="rinominaNome"
                                  type="text"
                                  maxlength="100"
                                  class="section-rename-input"
                                  placeholder="Nome della suddivisione"
                                  @keyup.enter="confermaRinomina(gruppo.nome)"
                                  @keyup.esc="rinominaSuddivisione = null"
                                />
                                <button
                                  type="button"
                                  class="section-rename-ok"
                                  @click="confermaRinomina(gruppo.nome)"
                                  title="Conferma il nuovo nome"
                                  aria-label="Conferma il nuovo nome"
                                >
                                  <i class="fa-solid fa-check"></i>
                                </button>
                                <button
                                  type="button"
                                  class="section-rename-undo"
                                  @click="rinominaSuddivisione = null"
                                  title="Annulla"
                                  aria-label="Annulla"
                                >
                                  <i class="fa-solid fa-xmark"></i>
                                </button>
                              </span>
                            </template>
                            <template v-else>
                              <span class="section-header-bar">
                                <i class="fa-solid fa-layer-group"></i>
                                <!-- [sc-48248] Il nome è il comando di rinomina: cliccarlo apre
                                     il campo. Prima c'era un bottone a parte lì accanto. -->
                                <button
                                  type="button"
                                  class="section-name"
                                  @click="apriRinomina(gruppo.nome)"
                                  title="Clicca sul nome per rinominare la suddivisione"
                                >
                                  {{ gruppo.nome }}
                                </button>
                                <!-- Rimozione: icona piccola accanto al nome, non un bottone
                                     pieno. Toglie il raggruppamento, non gli articoli. -->
                                <button
                                  type="button"
                                  class="section-remove"
                                  @click="rimuoviSuddivisione(gruppo.nome)"
                                  title="Togli la suddivisione (gli articoli restano)"
                                  aria-label="Togli la suddivisione"
                                >
                                  <i class="fa-solid fa-xmark"></i>
                                </button>
                                <span class="section-count">
                                  {{ gruppo.righe.length }}
                                  {{
                                    gruppo.righe.length === 1
                                      ? "articolo"
                                      : "articoli"
                                  }}
                                </span>
                                <span class="section-total"
                                  >Totale
                                  {{
                                    totaleSuddivisioneFormattato(gruppo)
                                  }}</span
                                >
                              </span>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                      <draggable
                        tag="tbody"
                        :list="gruppo.righe"
                        group="righe-preventivo"
                        handle=".drag-handle"
                        item-key="itemId"
                        ghost-class="quote-item-row--ghost"
                        drag-class="quote-item-row--dragging"
                        :animation="150"
                        @change="applicaSpostamento(gruppo, $event)"
                      >
                        <template #item="{ element: item }">
                          <tr
                            :class="{
                              'quote-item-row--incomplete':
                                isRowStockIncomplete(item),
                            }"
                            :title="rowStockWarning(item)"
                          >
                            <td class="drag-handle-cell">
                              <i
                                class="fa-solid fa-grip-vertical drag-handle"
                                title="Trascina per spostare l'articolo"
                              ></i>
                            </td>
                            <td class="item-code-cell">
                              {{
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                ).supplierCode ||
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                ).itemCode ||
                                "—"
                              }}
                            </td>
                            <td class="item-cell">
                              <div class="item-title">
                                {{ itemDisplay(item).title }}
                              </div>
                              <div
                                v-if="itemDisplay(item).meta"
                                class="item-meta"
                              >
                                {{ itemDisplay(item).meta }}
                              </div>
                              <!-- [sc-48248] Compare solo quando una suddivisione esiste:
                                 senza, sarebbe una tendina a una voce sola. -->
                              <!-- [sc-48248] Compare solo quando una suddivisione esiste:
                                   senza, sarebbe una tendina a una voce sola. Stessa veste
                                   degli altri campi del form. -->
                              <StatusSelect
                                v-if="nomiSuddivisioni.length"
                                class="section-move-select"
                                :model-value="item.sectionName || ''"
                                :options="opzioniSuddivisione"
                                placeholderIcon="fa-layer-group"
                                @update:modelValue="
                                  spostaInSuddivisione(item, $event)
                                "
                              />
                              <!-- [sc-48248] Nota libera: dentro la cella
                                   dell'articolo, così ogni articolo resta una
                                   riga sola e Sortable sa cosa sta spostando. -->
                              <input
                                v-if="notaAperta(item)"
                                type="text"
                                class="item-note-input"
                                maxlength="500"
                                :value="item.note || ''"
                                placeholder="Nota per il cliente — Invio per chiudere"
                                title="La nota si salva mentre scrivi: finisce nel preventivo al prossimo salvataggio"
                                @input="scriviNota(item, $event.target.value)"
                                @change="
                                  updateRowNote(item, $event.target.value)
                                "
                                @keyup.enter="$event.target.blur()"
                              />
                            </td>
                            <td>
                              {{
                                getItemFromStore(
                                  item.itemId,
                                  categoryHintForRow(item)
                                ).category
                              }}
                            </td>
                            <td>
                              <input
                                type="number"
                                class="panel-qty-input"
                                :value="rowQtyValue(item)"
                                :step="rowQtyStep(item)"
                                :title="rowQtyTitle(item)"
                                min="0"
                                @change="
                                  updateRowQty(
                                    item,
                                    +$event.target.value,
                                    $event.target
                                  )
                                "
                              />
                              <span class="panel-qty-unit">{{
                                rowQtyUnit(item)
                              }}</span>
                              <!-- Disponibilità mostrata solo se le scatole sono
                               calcolabili: senza mq/ml per scatola i numeri
                               sarebbero inventati. -->
                              <template
                                v-if="
                                  rowHasBoxData(item) &&
                                  isOrderableOutOfStock(
                                    getItemFromStore(
                                      item.itemId,
                                      categoryHintForRow(item)
                                    )
                                  )
                                "
                              >
                                <span class="item-order-queued-badge"
                                  >Esaurito</span
                                >
                                <span class="item-order-info-msg"
                                  >Necessario ordinarlo per la quantità
                                  richiesta.</span
                                >
                              </template>
                              <template
                                v-else-if="
                                  rowHasBoxData(item) &&
                                  isQtyExceedingStock(item)
                                "
                              >
                                <span
                                  class="item-order-queued-badge item-not-available-badge"
                                  >Non disponibile</span
                                >
                                <span class="item-order-info-msg"
                                  >Necessario ordinarne
                                  {{ qtyToOrderLabel(item) }} per la quantità
                                  richiesta.</span
                                >
                              </template>
                            </td>
                            <!-- [sc-48248] Prezzo e IVA si correggono qui, senza
                             riaprire la scheda dell'articolo. -->
                            <td>
                              <input
                                type="number"
                                class="panel-price-input"
                                :value="rowPriceValue(item)"
                                min="0"
                                step="0.01"
                                title="Prezzo netto applicato alla riga"
                                @change="
                                  updateRowPrice(
                                    item,
                                    $event.target.value,
                                    $event.target
                                  )
                                "
                              />
                              <span class="panel-qty-unit">{{
                                unitForRow(item)
                              }}</span>
                            </td>
                            <td
                              class="row-total-cell"
                              title="Prezzo × quantità, IVA esclusa"
                            >
                              {{
                                totaleRigaImponibileFormattato(
                                  item.price,
                                  rowQtyValue(item)
                                )
                              }}
                            </td>
                            <td>
                              <!-- [sc-48248] Stessa tendina degli altri campi del form, non
                                   quella nativa del browser. -->
                              <StatusSelect
                                class="panel-iva-select"
                                :model-value="item.iva ?? 22"
                                :options="ivaOptions"
                                placeholderIcon="fa-percent"
                                @update:modelValue="updateRowIva(item, $event)"
                              />
                            </td>
                            <td>
                              <!-- [sc-48248] Nota libera per prodotto -->
                              <button
                                type="button"
                                class="icons-button icons-button--plain"
                                :class="{ 'icons-button--on': !!item.note }"
                                @click="toggleNota(item)"
                                :title="
                                  item.note
                                    ? 'Modifica la nota di questo articolo'
                                    : 'Aggiungi una nota a questo articolo'
                                "
                                :aria-label="
                                  item.note ? 'Modifica nota' : 'Aggiungi nota'
                                "
                              >
                                <i class="fa-regular fa-comment-dots"></i>
                              </button>
                              <button
                                type="button"
                                class="icons-button icons-button--plain"
                                @click="
                                  removeItem(formData.items.indexOf(item))
                                "
                                title="Rimuovi articolo dalla lista"
                                aria-label="Rimuovi articolo dalla lista"
                              >
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </template>
                      </draggable>
                    </template>
                    <tbody>
                      <tr v-if="formData.items.length === 0">
                        <td colspan="9" class="no-result">
                          Nessun articolo presente
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="items-panel__footer">
                  {{ formData.items.length }}
                  {{ formData.items.length === 1 ? "articolo" : "articoli" }}
                </div>
              </aside>

              <!-- Salva ed esporta: sotto il riepilogo articoli aggiunti -->
              <div class="save-button-container">
                <button
                  id="save-quote"
                  type="button"
                  class="primary-btn"
                  @click="onCreateQuoteAndGeneratePdf"
                  :disabled="!canSaveCreate"
                  :title="
                    !canSaveCreate
                      ? motivoSalvataggioBloccato
                      : asOrder
                      ? 'Salva ordine ed esporta PDF'
                      : 'Salva preventivo ed esporta PDF'
                  "
                >
                  {{
                    asOrder
                      ? "Crea ordine ed esporta PDF"
                      : "Salva ed esporta PDF"
                  }}
                </button>
              </div>
            </div>
            <!-- /.quote-work-col -->
          </div>
          <!-- /.quote-work-row -->
        </form>
      </div>
      <!-- /.create-quote-main-col -->
    </div>
    <!-- /.create-quote-wrapper -->

    <VueFinalModal
      v-model="showBackModal"
      :clickToClose="true"
      :escToClose="true"
      classes="documents-modal"
      content-class="confirm-modal-content"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="showBackModal = false"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
        <h3 class="modal__title">Tornare indietro?</h3>
        <p class="modal__subtitle">Le modifiche non salvate andranno perse.</p>
        <div class="modal-actions">
          <button class="secondary-btn" @click="showBackModal = false">
            Annulla
          </button>
          <button class="primary-btn confirm-btn" @click="confirmGoBack">
            Conferma
          </button>
        </div>
      </template>
    </VueFinalModal>

    <!-- Modale "Crea articolo": crea l'articolo e lo auto-seleziona nel preventivo -->
    <CreateItemModal
      v-model="showCreateItemModal"
      :initial-name="searchQueryItem"
      @created="onItemCreated"
    />
  </main>
</template>

<script>
import logoPath from "@/assets/logo-houselet.png";
// import crypto from "crypto";
import axiosInstance from "@/axiosInstance";
import { generateQuotePdf } from "@/utilities/generateQuotePdf";
import {
  missingStockFields,
  hasIncompleteStockData,
  itemPerBox,
} from "@/utilities/itemStockData";
import debounce from "lodash/debounce";
// import { nextTick } from "process";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate, formatDecimal } from "../utilities/formatting";
import { totaleRigaImponibileFormattato } from "../utilities/rigaPreventivo";
import SearchableCombo from "./SearchableCombo.vue";
import StatusSelect from "@/components/StatusSelect.vue";
import CreateItemModal from "@/components/CreateItemModal.vue";
import FlatPickr from "vue-flatpickr-component";
import draggable from "vuedraggable";
import { Italian } from "flatpickr/dist/l10n/it.js";
import apriDocumento from "@/mixins/apriDocumento";
// import DuplicateQuoteModal from "./DuplicateQuoteModal.vue";

const KEY = {
  STOCK: (id) => `STOCK:${Number(id)}`,
};

const COLUMN_GROUPS = {
  area: [
    "piastrelle",
    "rivestimenti parete",
    "parquet",
    "laminati",
    "decking esterno",
  ],
  piece: ["sanitari", "rubinetteria", "box doccia", "accessori bagno"],
  linear: ["profili", "sistemi di scarico"],
  furniture: ["mobili", "porte e infissi"],
};

function getCategoryGroup(category) {
  for (const [group, cats] of Object.entries(COLUMN_GROUPS)) {
    if (cats.includes(category)) return group;
  }
  return "generic";
}

/* Categorie vendute a scatola/confezione (la quantità va in boxQuantity,
   non in pieces): tutto il gruppo area + linear, non solo le piastrelle. */
function isBoxBasedCategory(category) {
  const g = getCategoryGroup(category);
  return g === "area" || g === "linear";
}

/* Quantità in mq/ml corrispondente a N scatole, come multiplo esatto di
   perBox (evita 3 x 1,44 = 4,319999...). Stringa pronta per il campo input:
   punto decimale, zeri finali rimossi. */
function quantityFromBoxes(boxes, perBox) {
  const n = Number(boxes) || 0;
  const scaled = Math.round((Number(perBox) || 0) * 10000);
  if (!n || !scaled) return "";
  return ((n * scaled) / 10000)
    .toFixed(4)
    .replace(/0+$/, "")
    .replace(/\.$/, "");
}

/* Scatole intere necessarie per una quantità in mq/ml.
   Arrotonda per eccesso (si comprano scatole intere) ma con tolleranza: senza,
   l'errore float o l'arrotondamento del campo fa scattare una scatola in più
   (es. 4,32 / 1,44 = 3.0000000000000004 -> ceil = 4 scatole invece di 3). */
function boxesFromQuantity(quantity, perBox) {
  const qty = Number(quantity) || 0;
  const step = Number(perBox) || 0;
  if (!step || qty <= 0) return 0;
  const ratio = qty / step;
  const nearest = Math.round(ratio);
  const tolerance = Math.min(0.005 / step, 0.01);
  return Math.abs(ratio - nearest) <= tolerance ? nearest : Math.ceil(ratio);
}

// mq/ml persistiti dall'API: null sulle righe storiche e sugli articoli a pezzo
function mqFromApi(value) {
  const n = Number(value);
  return n > 0 ? n : null;
}

// mq/ml per scatola con fallback: se l'articolo non ha il dato, si assume
// 1 unità per scatola — stessa assunzione dell'API nel calcolo del totale
// (COALESCE(sqmPerBox, 1)) — così l'articolo resta comunque preventivabile.
function perBoxOrFallback(perBox) {
  const n = Number(perBox) || 0;
  return n > 0 ? n : 1;
}

// 👇 helper per location: stringa JSON o oggetto
const asLoc = (raw) => {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw; // è già un oggetto
};

// [sc-48248] Trascinamento delle righe: Sortable via vuedraggable. Il drag&drop
// nativo HTML5 non esiste su touch, disegna il fantasma di tutta la tabella e
// non permette di rilasciare in fondo, perché inserisce sempre prima del
// bersaglio.
export default {
  /* [sc-48258] La pagina serve due rotte: `preventivi/nuovo` e `ordini/nuovo`.
     Con `asOrder` quello che si salva nasce già ordine (pronta consegna), e si
     possono dichiarare subito saldo e consegna. Riuso invece di una seconda
     pagina: ricerca articoli, mq/scatole, suddivisioni, note e validazioni sono
     le stesse, e tenerle in due file significherebbe aggiornarle in due posti. */
  mixins: [apriDocumento],
  props: {
    asOrder: { type: Boolean, default: false },
  },
  components: {
    SearchableCombo,
    StatusSelect,
    CreateItemModal,
    FlatPickr,
    draggable,
  },
  beforeRouteLeave(to) {
    if (
      this.navigationConfirmed ||
      to.name === "login" ||
      !this.hasUnsavedChanges
    ) {
      this.navigationConfirmed = false;
      return true;
    }
    this.pendingNavigation = to;
    this.showBackModal = true;
    return false;
  },
  created() {
    this.$store
      .dispatch("fetchClients", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare i clienti: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    // this.$store.dispatch("fetchOperators");
    this.$store
      .dispatch("fetchItems", {
        limit: 10000,
      })
      .catch((err) => {
        // evita Uncaught (in promise)
        console.error("Impossibile caricare gli articoli: ", err.message);
        // puoi mostrare un toast o impostare un flag di errore
      });
    this.debouncedFetchItems = debounce(this.fetchItems, 200);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  computed: {
    /* [sc-48248] Nomi delle suddivisioni, nell'ordine in cui compaiono fra gli
       articoli; in coda quelle appena create, che non hanno ancora righe. */
    nomiSuddivisioni() {
      const nomi = [];
      for (const riga of this.formData.items || []) {
        const n = (riga.sectionName || "").trim();
        if (n && !nomi.includes(n)) nomi.push(n);
      }
      for (const n of this.suddivisioniVuote) {
        if (!nomi.includes(n)) nomi.push(n);
      }
      return nomi;
    },

    /* [sc-48248] Voci della tendina di spostamento: la prima toglie la riga
       da ogni suddivisione. */
    opzioniSuddivisione() {
      return [
        { value: "", label: "Senza suddivisione" },
        ...this.nomiSuddivisioni.map((nome) => ({ value: nome, label: nome })),
      ];
    },

    /* [sc-48248] Le righe raggruppate per la tabella. Gli articoli senza
       suddivisione stanno in cima: è come si sono sempre visti i preventivi, e
       un preventivo che non usa le suddivisioni non deve cambiare aspetto. */
    gruppiArticoli() {
      const righe = this.formData.items || [];
      const senza = righe.filter((r) => !(r.sectionName || "").trim());
      const gruppi = senza.length ? [{ nome: null, righe: senza }] : [];

      for (const nome of this.nomiSuddivisioni) {
        gruppi.push({
          nome,
          righe: righe.filter((r) => (r.sectionName || "").trim() === nome),
        });
      }
      return gruppi;
    },

    clients() {
      return this.$store.getters["clients/list"] ?? [];
    },
    // Indirizzo mostrato nel campo: "Ritiro in sede" quando non è consegna
    // (solo visuale; il valore reale formData.location.address resta invariato)
    addressModel: {
      get() {
        return this.formData.deliveryType === "ritiro"
          ? "Ritiro in sede"
          : this.formData.location.address;
      },
      set(v) {
        if (this.formData.deliveryType === "consegna") {
          this.formData.location.address = v;
        }
      },
    },
    // Ponte UI per la select "Modalità di consegna": il payload resta
    // "consegna" | "ritiro" | "". Stessa logica di azzeramento indirizzo.
    deliveryTypeModel: {
      get() {
        return this.formData.deliveryType;
      },
      set(v) {
        this.formData.deliveryType = v || "";
        if (this.formData.deliveryType !== "consegna") {
          this.formData.location.address = "";
        }
      },
    },
    selectedItem() {
      if (this.newItem.itemId) {
        return this.getItemFromStore(this.newItem.itemId, "STOCK");
      }
      return {};
    },
    selectedItemGroup() {
      return getCategoryGroup(this.selectedItem?.category);
    },
    quantityLabel() {
      if (this.selectedItemGroup === "area") return "Quantità scatole";
      if (this.selectedItemGroup === "linear") return "Quantità confezioni";
      return "Quantità pezzi";
    },
    mqFieldLabel() {
      if (this.selectedItemGroup === "linear") return "Quantità ML";
      return "Quantità Mq";
    },

    /* Ponte per v-model quantityInput */
    quantityInput: {
      get() {
        if (
          this.selectedItemGroup === "area" ||
          this.selectedItemGroup === "linear"
        ) {
          return this.newItem.boxQuantity;
        }
        return this.newItem.pieces;
      },
      set(v) {
        // scatole/confezioni/pezzi sono sempre interi: niente 2,5 scatole
        const n = Math.max(0, Math.round(+v || 0));
        if (this.selectedItemGroup === "area") {
          this.newItem.boxQuantity = n;
          const ppb = this.selectedItem.piecesPerBox || 1;
          this.newItem.pieces = n * ppb;
        } else if (this.selectedItemGroup === "linear") {
          this.newItem.boxQuantity = n;
          this.newItem.pieces = 0;
        } else {
          this.newItem.pieces = n;
        }
      },
    },

    /* Abilita "aggiungi articolo" solo con quantità numerica > 0 */
    canAddItem() {
      const hasSelectedItem = Boolean(this.newItem.itemId);
      const isAreaOrLinear =
        this.selectedItemGroup === "area" ||
        this.selectedItemGroup === "linear";
      const qty = isAreaOrLinear
        ? Number(this.newItem.boxQuantity)
        : Number(this.newItem.pieces);
      return hasSelectedItem && Number.isFinite(qty) && qty >= 1;
    },

    /* Articolo a mq/ml con la scheda incompleta: si può comunque preventivare,
       ma senza mq/scatola e pz/scatola il preventivo non è confermabile.
       Restituisce l'avviso e la rotta per completare la scheda. */
    missingBoxDataInfo() {
      const item = this.selectedItem;
      if (!this.showMqField || !item?.id) return null;
      const missing = missingStockFields(item);
      if (!missing.length) return null;
      return {
        text: `Scheda articolo incompleta (manca ${missing.join(
          ", "
        )}): puoi aggiungere l'articolo al preventivo, ma completa la scheda prima di confermarlo al cliente.`,
        route: {
          name: "listini-edit-item",
          params: { category: item.category, itemId: item.id },
        },
      };
    },

    /* mq/ml per scatola dell'articolo selezionato: passo di incremento del
       campo mq (una freccia = una scatola) */
    mqPerBox() {
      const s = this.selectedItem || {};
      const perBox =
        this.selectedItemGroup === "linear"
          ? Number(s.mlPerBox) || 0
          : Number(s.sqmPerBox) || 0;
      return perBox > 0 ? perBox : 0;
    },

    /* Riepilogo sotto il campo mq: l'operatore scrive i mq, ma il preventivo va
       a scatole intere. L'hint rende esplicito cosa viene effettivamente venduto. */
    mqSummary() {
      if (!this.showMqField) return "";
      const perBox = this.mqPerBox;
      // dato mancante: al posto del riepilogo si mostra l'avviso con il link
      if (!perBox) return "";
      const boxes = Number(this.newItem.boxQuantity) || 0;
      const isLinear = this.selectedItemGroup === "linear";
      const unit = isLinear ? "ml" : "mq";
      if (!boxes) return `${formatDecimal(perBox)} ${unit}/scatola`;
      const label = isLinear ? "confezioni" : "scatole";
      const total = formatDecimal(quantityFromBoxes(boxes, perBox));
      const ppb = Number(this.selectedItem?.piecesPerBox) || 0;
      const pieces = !isLinear && ppb ? ` · ${boxes * ppb} pz totali` : "";
      return `${boxes} ${label} = ${total} ${unit}${pieces}`;
    },

    /* Anteprima riga (nuova semantica IVA esclusa): netto applicato, quantità
       effettiva, e importi imponibile/imposta/totale dell'intera riga. Valori 0
       se la quantità non è ancora valida (nessun NaN). */
    previewAppliedNet() {
      const personalized = this.optionalNonNegativeNumber(
        this.newItem.discountedPrice
      );
      return personalized !== null
        ? personalized
        : Number(this.newItem.price) || 0;
    },
    previewEffectiveQty() {
      const group = this.selectedItemGroup;
      if (group === "area" || group === "linear") {
        const typed = this.typedMqQuantity();
        if (typed !== null) return Number(typed) || 0;
        return quantityFromBoxes(
          Number(this.newItem.boxQuantity) || 0,
          perBoxOrFallback(this.mqPerBox)
        );
      }
      return Number(this.newItem.pieces) || 0;
    },
    linePreview() {
      const net = Number(this.previewAppliedNet) || 0;
      const qty = Number(this.previewEffectiveQty) || 0;
      const iva = Number(this.newItem.iva) || 0;
      const taxable = +(net * qty).toFixed(2);
      const tax = +((taxable * iva) / 100).toFixed(2);
      const gross = +(taxable + tax).toFixed(2);
      return { taxable, tax, gross };
    },
    previewFormatted() {
      const p = this.linePreview;
      return {
        taxable: formatDecimal(p.taxable),
        tax: formatDecimal(p.tax),
        gross: formatDecimal(p.gross),
      };
    },

    showMqField() {
      const s = this.selectedItem || {};
      if (!s || !s.category) return false;
      return (
        this.selectedItemGroup === "area" || this.selectedItemGroup === "linear"
      );
    },

    items() {
      return this.$store.getters["items/list"] ?? [];
    },

    filteredClients() {
      const query = (this.searchQueryClient || "").toLowerCase();
      // console.log("thisclients", this.clients);
      return this.clients
        .filter((c) => (c.clientName || "").toLowerCase().includes(query))
        .slice(0, 5);
    },

    // Tutti i nomi da mostrare nella colonna "Articolo"
    itemNames() {
      return (this.formData.items || []).map(
        (row) =>
          this.getItemName(row.itemId, this.categoryHintForRow(row)) || ""
      );
    },

    // Lunghezza massima in caratteri tra i nomi
    maxItemLen() {
      return this.itemNames.reduce((m, s) => Math.max(m, s.length), 0);
    },

    // Larghezza dinamica della colonna "Articolo" in ch, con limiti per non rompere il layout
    // - min 180px (leggibile anche con nomi brevi)
    // - valore centrale in ch (caratteri) = maxArtLen + 6 (un po' di respiro)
    // - max 52vw (mai oltre metà viewport nel modale)
    itemColWidth() {
      const ch = Math.max(10, Math.min(this.maxItemLen + 6, 72)); // clamp “logico”
      return `clamp(180px, ${ch}ch, 50vw)`;
    },

    showSelectedItemOrderAlert() {
      return this.isOrderableOutOfStock(this.selectedItem);
    },
    selectedItemOrderLabel() {
      return this.itemSearchLabel(this.selectedItem);
    },
    canSaveCreate() {
      // indirizzo non obbligatorio, ma è obbligatorio scegliere la modalità
      // (consegna o ritiro) e serve almeno un articolo
      if (!this.formData.items.length || !this.formData.deliveryType)
        return false;
      // [sc-48258] Su un ordine saldato il metodo di pagamento non è più un
      // dettaglio: è il metodo con cui si registra l'incasso.
      if (this.asOrder && this.ordineSaldato && !this.formData.payment_method) {
        return false;
      }
      return true;
    },
    // [sc-48258] Perché il salvataggio è bloccato: con tre condizioni diverse
    // un titolo unico («compila i campi obbligatori») non dice quale manca.
    motivoSalvataggioBloccato() {
      if (!this.formData.items.length) return "Aggiungi almeno un articolo";
      if (!this.formData.deliveryType)
        return "Scegli la modalità: consegna o ritiro";
      if (this.asOrder && this.ordineSaldato && !this.formData.payment_method)
        return "Scegli il metodo di pagamento: serve a registrare l'incasso";
      return "";
    },
    notaConsegna() {
      if (!this.ordineSaldato)
        return "Si dichiara solo su un ordine pagato: la consegna si chiude a saldo incassato.";
      if (this.ordineConsegnato)
        return "La merce esce dal magazzino al salvataggio: se non basta, l'ordine non viene creato.";
      return "L'ordine resta in magazzino, pronto per la spedizione.";
    },
    hasUnsavedChanges() {
      const f = this.formData;
      return !!(
        (f.items && f.items.length) ||
        (f.location?.address || "").trim() ||
        f.clientId ||
        (f.technical_queries || "").trim() ||
        this.newItem?.itemId
      );
    },
  },
  data() {
    return {
      dateConfig: {
        locale: Italian,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        monthSelectorType: "static",
      },
      showBackModal: false,
      pendingNavigation: null,
      navigationConfirmed: false,
      // loading per i 3 combobox
      clientsLoading: false,
      itemsLoading: false,
      // lista clienti filtrata per il combobox (evitiamo il vecchio computed)
      comboClients: [],

      showDuplicateModal: false,
      lastDuplicateQuoteInfo: { quoteId: null, address: null },
      // [sc-48258] Pronta consegna. `ordineDuplicatoConfermato` resta falso
      // finché l'operatore non risponde all'avviso sul duplicato: è ciò che
      // permette al server di scavalcare il blocco una volta sola, su richiesta.
      ordineSaldato: false,
      ordineConsegnato: false,
      ordineDuplicatoConfermato: false,
      showDupDocs: false,
      dupDocuments: [],
      // Modale "Crea articolo" (richiamo da campo ricerca articolo)
      showCreateItemModal: false,

      dupLoading: false,
      dupError: "",
      dupQuote: null,

      showDropdown: false,
      searchQueryClient: "",
      searchQueryItem: "",
      // mq/ml digitati dall'operatore: valore libero, non riscritto dalla UI.
      // Le scatole del preventivo sono derivate da qui (vedi watcher mqInput).
      mqInput: "",
      filteredItems: [],
      // Paginazione risultati ricerca articolo (fix #2)
      itemsPage: 1, // ultima pagina caricata con successo
      itemsRequestedPage: null, // pagina della richiesta in volo (pending)
      itemsTotalPages: 1,
      itemsTotalItems: null,
      // [sc-48337] L'API ferma il conteggio a 10.000: oltre quella soglia il
      // totale va mostrato come "10.000+". Il selettore resta a paginazione
      // numerata perché SearchableCombo è condiviso con la ricerca clienti, che
      // non ha il cursore; qui si pesca fra le prime pagine, quindi l'OFFSET
      // profondo non è un problema reale.
      itemsTotalIsCapped: false,
      itemsSearchQuery: "",
      itemsRequestId: 0,
      selectedByKey: {},
      pendingOrderItems: {},
      orderNote: "",
      panelVisible: true,
      selectedIndex: -1, // Indice dell'opzione attualmente evidenziata
      activeSearch: null, // "item" o "client" o null
      response: "",

      image: logoPath,
      formData: {
        location: {
          name: "",
          address: "",
          placeId: "",
          latitude: "",
          longitude: "",
        },
        technical_queries: "",
        clientId: "",
        items: [],
        date: "",
        payment_method: "",
        deliveryType: "",
        hasPackagingFee: false,
      },
      newItem: {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        discountedPrice: "",
        iva: 0,
      },
      errorMessage: "",
      successMessage: "",
      selectedPlaceId: "",
      paymentOptions: [
        { value: "Contanti", label: "Contanti" },
        { value: "Carta di credito", label: "Carta di credito" },
        { value: "Bonifico", label: "Bonifico" },
        { value: "Scegli successivamente", label: "Scegli successivamente" },
      ],
      deliveryOptions: [
        { value: "consegna", label: "Presso cliente", icon: "fa-truck" },
        { value: "ritiro", label: "Ritiro", icon: "fa-store" },
      ],
      // [sc-48248] Righe con la nota aperta a mano, per itemId. Una nota già
      // scritta si vede comunque: qui stanno solo quelle da scrivere.
      noteAperte: {},
      // [sc-48248] Suddivisioni create ma ancora senza articoli dentro. Il
      // nome sta sulla riga, quindi una suddivisione vuota non esiste a DB:
      // vive qui finché non ci si sposta dentro il primo articolo.
      suddivisioniVuote: [],
      nuovaSuddivisioneAperta: false,
      nuovaSuddivisioneNome: "",
      rinominaSuddivisione: null,
      rinominaNome: "",
      ivaOptions: [
        { value: 22, label: "22%" },
        { value: 10, label: "10%" },
        { value: 4, label: "4%" },
        { value: 0, label: "0%" },
      ],
    };
  },

  methods: {
    /* [sc-48248] Suddivisioni del preventivo ("Bagno 2"). Il nome sta sulla
       riga: raggruppare per nome significa che non esistono sezioni orfane di
       articoli né articoli orfani di sezione. */
    apriNuovaSuddivisione() {
      this.nuovaSuddivisioneAperta = true;
      this.nuovaSuddivisioneNome = "";
    },

    annullaNuovaSuddivisione() {
      this.nuovaSuddivisioneAperta = false;
      this.nuovaSuddivisioneNome = "";
    },

    confermaNuovaSuddivisione() {
      const nome = (this.nuovaSuddivisioneNome || "").trim();
      if (!nome) {
        this.$toast.error("Dai un nome alla suddivisione.");
        return;
      }
      if (this.nomiSuddivisioni.includes(nome)) {
        this.$toast.error(`La suddivisione «${nome}» esiste già.`);
        return;
      }
      this.suddivisioniVuote = [...this.suddivisioniVuote, nome];
      this.annullaNuovaSuddivisione();
      this.$toast.success(
        `Suddivisione «${nome}» aggiunta: spostaci dentro gli articoli.`
      );
    },

    apriRinomina(nome) {
      this.rinominaSuddivisione = nome;
      this.rinominaNome = nome;
    },

    confermaRinomina(vecchio) {
      const nuovo = (this.rinominaNome || "").trim();
      if (!nuovo) {
        this.$toast.error("Il nome non può restare vuoto.");
        return;
      }
      if (nuovo !== vecchio && this.nomiSuddivisioni.includes(nuovo)) {
        this.$toast.error(`La suddivisione «${nuovo}» esiste già.`);
        return;
      }
      for (const riga of this.formData.items || []) {
        if ((riga.sectionName || "").trim() === vecchio)
          riga.sectionName = nuovo;
      }
      this.suddivisioniVuote = this.suddivisioniVuote.map((n) =>
        n === vecchio ? nuovo : n
      );
      this.rinominaSuddivisione = null;
      this.riallineaPosizioni();
    },

    /* Toglie la suddivisione, non gli articoli: tornano fuori da ogni
       raggruppamento, dove stavano prima. */
    rimuoviSuddivisione(nome) {
      for (const riga of this.formData.items || []) {
        if ((riga.sectionName || "").trim() === nome) riga.sectionName = null;
      }
      this.suddivisioniVuote = this.suddivisioniVuote.filter((n) => n !== nome);
      this.riallineaPosizioni();
    },

    spostaInSuddivisione(riga, nome) {
      const n = (nome || "").trim();
      riga.sectionName = n || null;
      // Appena una suddivisione ha un articolo dentro non è più "vuota": da
      // quel momento esiste perché lo dice la riga.
      if (n)
        this.suddivisioniVuote = this.suddivisioniVuote.filter((x) => x !== n);
      this.riallineaPosizioni();
    },

    /* [sc-48248] Spostamento di una riga, da Sortable.
       `gruppo.righe` è una lista derivata: Sortable la riordina, ma la verità
       sta in `formData.items`. Qui si legge l'ordine appena prodotto e lo si
       riscrive nell'elenco vero, una volta sola. */
    applicaSpostamento(gruppo, evento) {
      // I gruppi si leggono PRIMA di toccare `sectionName`: scrivere quel campo
      // invalida il computed e si perderebbe l'ordine appena prodotto.
      const gruppi = this.gruppiArticoli;
      const nuovoOrdine = gruppi.flatMap((g) => g.righe);

      const arrivata = evento?.added?.element;
      if (arrivata) arrivata.sectionName = gruppo.nome || null;
      if (gruppo.nome) {
        this.suddivisioniVuote = this.suddivisioniVuote.filter(
          (n) => n !== gruppo.nome
        );
      }

      this.formData.items.splice(0, this.formData.items.length, ...nuovoOrdine);
      this.riallineaPosizioni();
    },

    /* [sc-48248] Totale lordo di una suddivisione: netto applicato × quantità
       effettiva × aliquota, riga per riga. È il numero che dice di chi è il
       prezzo quando dentro al gruppo ci sono righe a zero — il caso del kit. */
    totaleSuddivisione(gruppo) {
      return (gruppo?.righe || []).reduce((somma, riga) => {
        const netto = Number(riga.price) || 0;
        const quantita = Number(this.rowQtyValue(riga)) || 0;
        const iva = Number(riga.iva ?? 22);
        return somma + netto * quantita * (1 + iva / 100);
      }, 0);
    },

    // [sc-49019] Totale di riga in tabella, IVA esclusa.
    totaleRigaImponibileFormattato,

    totaleSuddivisioneFormattato(gruppo) {
      return `€ ${formatDecimal(this.totaleSuddivisione(gruppo))}`;
    },

    /* [sc-48248] `position` deve raccontare quello che si vede: si rinumera
       seguendo l'ordine di lettura della tabella, gruppo per gruppo. */
    riallineaPosizioni() {
      let i = 1;
      for (const gruppo of this.gruppiArticoli) {
        for (const riga of gruppo.righe) riga.position = i++;
      }
    },

    goBack() {
      this.pendingNavigation = null;
      // Nessuna modifica: torna indietro senza conferma.
      if (!this.hasUnsavedChanges) {
        this.navigationConfirmed = true;
        this.$router.back();
        return;
      }
      this.showBackModal = true;
    },
    confirmGoBack() {
      this.navigationConfirmed = true;
      this.showBackModal = false;
      if (this.pendingNavigation) {
        this.$router.push(this.pendingNavigation);
      } else {
        this.$router.back();
      }
    },
    // Guardia reload/chiusura tab nativa del browser: mostra il dialog
    // nativo di conferma quando ci sono modifiche non salvate.
    handleBeforeUnload(e) {
      if (!this.hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = "";
    },
    onSearchClient(q) {
      this.clientsLoading = true;
      const query = (q || "").toLowerCase();
      this.comboClients = (this.clients || [])
        .filter((c) => (c.clientName || "").toLowerCase().includes(query))
        .slice(0, 8);
      this.clientsLoading = false;
    },
    onSearchItem(q) {
      this.itemsLoading = true;
      this.debouncedFetchItems(q.trim());
    },
    async loadDuplicateQuote() {
      const id = this.lastDuplicateQuoteInfo?.quoteId;
      // console.debug("[dup] about to load", {
      //   lastDuplicateQuoteInfo: this.lastDuplicateQuoteInfo,
      //   id,
      // });
      if (!id) return;

      this.dupLoading = true;
      this.dupError = "";
      this.dupQuote = null;

      try {
        const { data } = await axiosInstance.get(`/quote/${id}`, {
          withCredentials: true,
        });
        // console.debug("[dup] GET /quote/:id response", data);

        // accetta sia {quote:{...}} sia {...} diretto
        const qRaw = data?.quote ?? data ?? {};
        // documents sia in quote che top-level
        this.dupDocuments = qRaw.documents ?? data?.documents ?? [];

        // parse location
        let parsedLocation = null;
        try {
          parsedLocation = asLoc(qRaw.location) || null;
        } catch {
          parsedLocation = null;
        }

        const items = (qRaw.quote_items || qRaw.items || []).map((qi) => {
          const cat = qi.item?.category || qi.category || "";
          const isBoxBased = isBoxBasedCategory(cat);
          return {
            category: cat,
            itemName: qi.item?.itemName || qi.item?.subBrand || qi.itemName,
            brand: qi.item?.subBrand || qi.brand,
            boxQuantity: isBoxBased ? qi.quantity : 0,
            pieces: isBoxBased ? 0 : qi.quantity,
            mqQuantity: isBoxBased ? mqFromApi(qi.mqQuantity) : null,
            iva: qi.iva ?? 22,
            price: Number(qi.price ?? 0),
            discountedPrice:
              qi.discountedPrice != null ? Number(qi.discountedPrice) : null,
          };
        });

        this.dupQuote = {
          ...qRaw,
          location: parsedLocation,
          totalPrice: qRaw.totalPrice ?? data?.totalPrice ?? null,
          items,
        };

        // console.debug("[dup] normalized dupQuote", this.dupQuote);
      } catch (e) {
        // console.error("[dup] load error", e?.response || e);
        this.dupError =
          e?.response?.data?.message ||
          "Impossibile caricare il preventivo esistente.";
      } finally {
        this.dupLoading = false;
      }
    },

    openDuplicateModal(quoteId, address, isOrder = false) {
      this.lastDuplicateQuoteInfo = {
        quoteId: quoteId ?? null,
        address: address ?? null,
        // [sc-48258] Il doppione può essere un preventivo o un ordine: il
        // server lo dice in `details.isOrder` e l'avviso lo ripete, perché
        // «esiste già un preventivo» manderebbe a cercare la cosa sbagliata.
        isOrder: isOrder === true,
      };
      this.dupError = "";
      this.dupQuote = null;
      this.showDuplicateModal = true;

      // 👇 evita di affidarti solo ai watcher
      if (this.lastDuplicateQuoteInfo.quoteId) {
        this.loadDuplicateQuote();
      }
    },

    closeDuplicateModal() {
      this.showDuplicateModal = false;
    },

    /* [sc-48258] «Crea comunque l'ordine»: l'unicità cliente+indirizzo è una
       guardia contro due preventivi aperti per lo stesso cantiere, non contro
       una vendita. Qui l'operatore ha letto l'avviso e decide: il flag parte
       col salvataggio successivo e vale solo per quello. */
    async creaOrdineNonostanteDuplicato() {
      this.ordineDuplicatoConfermato = true;
      this.showDuplicateModal = false;
      await this.onCreateQuoteAndGeneratePdf();
      // Il flag non resta acceso: un secondo salvataggio deve tornare a
      // chiedere, altrimenti l'avviso lo si scavalca una volta e per sempre.
      this.ordineDuplicatoConfermato = false;
    },

    // util formattazioni (riusate nel template)
    number(v) {
      return (typeof v === "number" ? v : Number(v || 0)).toFixed(2);
    },
    money(v) {
      return `€ ${this.number(v)}`;
    },
    formatDocName(name) {
      return (
        (name ?? "")
          .toString()
          // prima togli eventuale ".dev" immediatamente prima di ".pdf"
          .replace(/\.dev(?=\.pdf$)/i, "")
          // poi rimuovi "_N_<numero>.pdf" in fondo
          .replace(/_N_\d+\.pdf$/i, "")
      );
    },
    formatToLocalDate,

    // azioni footer
    onChangeAddress() {
      this.showDuplicateModal = false;
      this.$nextTick(() => document.getElementById("autocomplete")?.focus());
    },
    /* [sc-48248] Righe di un preventivo del server → righe della form.
       Usata sia dal modale dei duplicati sia dalla duplica esplicita: la
       conversione è la stessa, cambia solo cosa si tiene del resto. */
    mappaRigheDaPreventivo(q) {
      const righe = (q?.quote_items || [])
        .map((qi) => {
          if (!qi.item) return null;
          const cat = qi.item.category;
          const isBoxBased = isBoxBasedCategory(cat);
          return {
            itemId: qi.item.id,
            category: cat,
            boxQuantity: isBoxBased ? qi.quantity : 0,
            pieces: isBoxBased ? 0 : qi.quantity,
            mqQuantity: isBoxBased ? mqFromApi(qi.mqQuantity) : null,
            price: Number(qi.price).toFixed(2),
            discountedPrice:
              qi.discountedPrice != null ? Number(qi.discountedPrice) : null,
            iva: qi.iva ?? 22,
            // [sc-48248] Nota, suddivisione e ordine seguono l'articolo: un
            // preventivo copiato che perde le note non è una copia.
            note: qi.note || null,
            sectionName: qi.sectionName || null,
            position: qi.position ?? null,
          };
        })
        .filter(Boolean);

      // cache per etichette/nomi in tabella
      (q?.quote_items || []).forEach((qi) => {
        if (qi.item) this.selectedByKey[KEY.STOCK(qi.item.id)] = qi.item;
      });

      return righe;
    },

    /* [sc-48248] Duplica chiesta dall'elenco preventivi (`?duplicaDa=<id>`).
       Si portano dietro solo gli articoli: cliente e indirizzo restano da
       scegliere, ed è il senso della richiesta — a DB un preventivo senza
       cliente non esiste, quindi finché non lo si indica non si salva nulla. */
    async caricaDaDuplicazione(sourceId) {
      try {
        const { data } = await axiosInstance.get(`/quote/${sourceId}`, {
          withCredentials: true,
        });
        const q = data?.quote;
        if (!q) throw new Error("preventivo non trovato");

        this.formData = {
          ...this.formData,
          items: this.mappaRigheDaPreventivo(q),
          payment_method: q.payment_method || "",
          technical_queries: q.technical_queries || "",
        };
        this.newItem = this.resetNewItem();

        this.$toast.info(
          `Articoli del preventivo #${q.id} copiati. Scegli cliente e indirizzo, poi salva.`
        );
      } catch (err) {
        this.$toast.error("Impossibile duplicare il preventivo.");
        console.error("Errore durante la duplicazione del preventivo: ", err);
      }
    },

    async onDuplicateWithEdit() {
      const sourceId = this.lastDuplicateQuoteInfo?.quoteId;
      this.showDuplicateModal = false;

      if (!sourceId) return;

      try {
        // se il dettaglio non è già caricato, lo carico ora
        if (!this.dupQuote || this.dupQuote.id !== sourceId) {
          this.dupLoading = true;
          const { data } = await axiosInstance.get(`/quote/${sourceId}`, {
            withCredentials: true,
          });
          const loc = asLoc(data?.quote?.location);
          this.dupQuote = { ...data.quote, location: loc };
        }

        const q = this.dupQuote;

        const mappedItems = this.mappaRigheDaPreventivo(q);

        // compilo la form con i dati del preventivo esistente
        this.formData = {
          ...this.formData,
          clientId: q.clientId,
          payment_method: q.payment_method || "",
          technical_queries: q.technical_queries || "",
          items: mappedItems,
          location: {
            name: "",
            address: "",
            placeId: "",
            latitude: "",
            longitude: "",
          }, // ← SVUOTO
        };

        this.newItem = this.resetNewItem();

        this.$nextTick(() => document.getElementById("autocomplete")?.focus());
        this.$toast.info(
          `Contenuto del preventivo #${q.id} copiato. Inserisci un indirizzo diverso e salva.`
        );
      } catch (e) {
        this.$toast.error("Impossibile duplicare questo preventivo ora.");
      } finally {
        this.dupLoading = false;
      }
    },
    onViewedExisting() {
      // opzionale: analytics/log
    },

    categoryHintForRow(row) {
      if (row?.category) return row.category;
      return "STOCK";
    },
    rowCategoryGroup(row) {
      const it = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      return getCategoryGroup(it?.category);
    },
    isStockTiles(row) {
      return this.rowCategoryGroup(row) === "area";
    },
    qtyCell(row) {
      const group = this.rowCategoryGroup(row);
      if (group === "area" || group === "linear")
        return Number(row.boxQuantity || 0);
      return Number(row.pieces || row.quantity || 0);
    },
    getItemFromStore(id) {
      if (!id) return {};

      const key = KEY.STOCK(id);

      if (this.selectedByKey[key]) return this.selectedByKey[key];

      const stk =
        (this.items || []).find((i) => i.id === id) ||
        (this.filteredItems || []).find((i) => i.id === id);
      if (stk) {
        this.selectedByKey[key] = stk;
        return stk;
      }
      return {};
    },

    // Mappa azioni store
    ...mapActions(["uploadQuoteDocument", "createOrder"]),

    itemSearchLabel(it) {
      if (!it) return "";
      return it.itemName
        ? `${it.itemName} ${it.measureDesc || ""}`.trim()
        : `${it.subBrand || ""} ${it.fixtureType || ""} ${
            it.fixturePosition || ""
          }`.trim();
    },

    // Riga secondaria del risultato ricerca: brand + formato + finiture.
    itemFormatFinish(it) {
      return [it?.brand, it?.formatLabel, it?.finish]
        .filter(Boolean)
        .join(" · ");
    },

    warehouseCount(item) {
      const stock = Number(item?.warehouse?.inWarehouse ?? item?.inWarehouse);
      return Number.isFinite(stock) ? stock : 0;
    },

    isOrderableOutOfStock(item) {
      return !!item?.id && this.warehouseCount(item) <= 0;
    },

    /* Giacenza mostrata nell'unità di vendita: mq/ml per gli articoli a
       scatola (le scatole restano nel tooltip), pezzi per gli altri. */
    /* Articolo venduto a scatola ma senza mq/ml per scatola: le scatole non
       sono calcolabili, quindi giacenza e quantità da ordinare non vengono
       mostrate (sarebbero numeri inventati). */
    hasBoxData(item) {
      const group = getCategoryGroup(item?.category);
      if (group !== "area" && group !== "linear") return true;
      return itemPerBox(item) > 0;
    },

    rowHasBoxData(row) {
      return this.hasBoxData(this.rowStockItem(row));
    },

    stockLabel(item) {
      const count = this.warehouseCount(item);
      const group = getCategoryGroup(item?.category);
      if (group !== "area" && group !== "linear") return `${count} sc.`;
      const perBox = itemPerBox(item);
      // senza mq/ml per scatola la giacenza in mq non è ricavabile
      if (!perBox) return "—";
      const unit = group === "linear" ? "ml" : "mq";
      return `${formatDecimal(quantityFromBoxes(count, perBox))} ${unit}`;
    },

    stockTitle(item) {
      const count = this.warehouseCount(item);
      const group = getCategoryGroup(item?.category);
      if (group === "linear")
        return itemPerBox(item)
          ? `${count} ${count === 1 ? "confezione" : "confezioni"} in magazzino`
          : "Giacenza non calcolabile: manca ML / confezione nella scheda articolo";
      if (group === "area")
        return itemPerBox(item)
          ? `${count} ${count === 1 ? "scatola" : "scatole"} in magazzino`
          : "Giacenza non calcolabile: manca M² / scatola nella scheda articolo";
      return `${count} pz in magazzino`;
    },

    isQtyExceedingStock(row) {
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      if (!item?.id) return false;
      const stock = this.warehouseCount(item);
      if (stock <= 0) return false;
      return this.qtyCell(row) > stock;
    },

    /* mq/ml scritti a mano per riga, indicizzati per itemId: il PDF li usa al
       posto della quantità ricavata dalle scatole. */
    mqOverridesForPdf() {
      const map = {};
      (this.formData.items || []).forEach((row) => {
        const mq = Number(row?.mqQuantity);
        if (row?.itemId && mq > 0) map[row.itemId] = mq;
      });
      return map;
    },

    /* mq/ml digitati nel form, se validi (altrimenti null: la riga userà
       l'equivalente delle scatole) */
    typedMqQuantity() {
      if (!this.showMqField) return null;
      const n = Number(this.mqInput);
      return n > 0 ? n : null;
    },

    /* Allinea il campo mq alla quantità già presente in newItem (es. quando si
       riseleziona un articolo che ha già una quantità impostata). */
    syncMqInputFromBoxes() {
      const perBox = perBoxOrFallback(this.mqPerBox);
      const boxes = Number(this.newItem.boxQuantity) || 0;
      this.mqInput = boxes ? quantityFromBoxes(boxes, perBox) : "";
    },

    /* mq/ml per scatola della riga: 0 solo se l'articolo non è venduto a
       scatola, altrimenti il dato dell'articolo (o 1 se manca) */
    rowPerBox(row) {
      const group = this.rowCategoryGroup(row);
      if (group !== "area" && group !== "linear") return 0;
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      const perBox =
        group === "linear"
          ? Number(it.mlPerBox) || 0
          : Number(it.sqmPerBox) || 0;
      return perBoxOrFallback(perBox);
    },

    /* Unità della colonna quantità: mq/ml per gli articoli a scatola, pz per gli
       altri. Le scatole restano la quantità del preventivo ma non si mostrano. */
    rowQtyUnit(row) {
      const group = this.rowCategoryGroup(row);
      if (!this.rowPerBox(row)) return group === "linear" ? "ml" : "pz";
      return group === "linear" ? "ml" : "mq";
    },

    rowQtyStep(row) {
      return this.rowPerBox(row) ? "any" : "1";
    },

    /* Valore in colonna quantità: i mq/ml scritti dall'operatore (non riscritti),
       con fallback all'equivalente delle scatole; pezzi per gli altri articoli */
    rowQtyValue(row) {
      const perBox = this.rowPerBox(row);
      if (!perBox) return this.qtyCell(row);
      const typed = Number(row.mqQuantity);
      if (typed > 0) return row.mqQuantity;
      return quantityFromBoxes(Number(row.boxQuantity) || 0, perBox);
    },

    rowQtyTitle(row) {
      const perBox = this.rowPerBox(row);
      if (!perBox) return "Quantità in pezzi";
      // senza mq/ml per scatola le scatole non sono calcolabili: si dice
      // perché, invece di mostrare un numero inventato
      if (!this.rowHasBoxData(row)) {
        return "Scatole non calcolabili: completa la scheda articolo";
      }
      // scatole ricalcolate dai mq mostrati con il dato corrente dell'articolo:
      // boxQuantity salvato può essere vecchio (scheda completata dopo il
      // preventivo). È lo stesso calcolo che l'API rifà alla conferma.
      const requested = Number(this.rowQtyValue(row)) || 0;
      const boxes = requested > 0 ? boxesFromQuantity(requested, perBox) : 0;
      const isLinear = this.rowCategoryGroup(row) === "linear";
      const label =
        boxes === 1
          ? isLinear
            ? "confezione"
            : "scatola"
          : isLinear
          ? "confezioni"
          : "scatole";
      const unit = isLinear ? "ml" : "mq";
      const total = formatDecimal(quantityFromBoxes(boxes, perBox));
      return `${boxes} ${label} intere (${total} ${unit}) per i ${formatDecimal(
        requested
      )} ${unit} richiesti`;
    },

    updateRowQty(row, val, inputEl = null) {
      const group = this.rowCategoryGroup(row);
      const perBox = this.rowPerBox(row);
      const requested = Number(val) || 0;
      // per togliere l'articolo si usa il pulsante rimuovi, non la quantità 0
      if (requested <= 0) {
        this.$toast.error(
          "La quantità deve essere maggiore di 0: usa il pulsante rimuovi per eliminare l'articolo."
        );
        if (inputEl) inputEl.value = this.rowQtyValue(row);
        return;
      }
      if (perBox) {
        // l'operatore scrive i mq/ml: il valore resta quello digitato, le scatole
        // intere da ordinare sono derivate per il magazzino
        row.mqQuantity = requested;
        const boxes = Math.max(1, boxesFromQuantity(requested, perBox));
        row.boxQuantity = boxes;
        const storeItem = this.getItemFromStore(
          row.itemId,
          this.categoryHintForRow(row)
        );
        row.pieces = boxes * (storeItem?.piecesPerBox || 1);
        return;
      }
      const n = Math.max(1, Math.round(requested));
      if (group === "area" || group === "linear") {
        row.boxQuantity = n;
        const storeItem = this.getItemFromStore(
          row.itemId,
          this.categoryHintForRow(row)
        );
        row.pieces = n * (storeItem?.piecesPerBox || 1);
      } else {
        row.pieces = n;
      }
      // il binding :value non si aggiorna se il valore arrotondato coincide con
      // quello già in stato: riallineo il campo a mano
      if (inputEl && +inputEl.value !== n) inputEl.value = n;
    },

    /* [sc-48248] Nota libera del prodotto. Si vede se c'è, o se l'operatore
       ha aperto il campo per scriverla. */
    notaAperta(row) {
      return !!row?.note || !!this.noteAperte[row?.itemId];
    },

    toggleNota(row) {
      const id = row?.itemId;
      if (id == null) return;
      this.noteAperte = { ...this.noteAperte, [id]: !this.noteAperte[id] };
    },

    /* [sc-48248] Mentre si scrive il testo si tiene com'è, spazi compresi:
       ripulirlo a ogni tasto cancellerebbe lo spazio appena digitato. La
       ripulitura avviene quando il campo perde il fuoco (o con Invio, che lo
       fa perdere), in `updateRowNote`. */
    scriviNota(row, val) {
      row.note = val === "" ? null : val;
    },

    updateRowNote(row, val) {
      const testo = String(val ?? "").trim();
      // Vuota = nessuna nota: l'API tratta allo stesso modo stringa vuota e
      // null, e tenere "" vorrebbe dire salvare una nota che non si vede.
      row.note = testo || null;
    },

    /* [sc-48248] Prezzo della riga, editabile in tabella.
       Lo zero è ammesso: è il prezzo dei prodotti dentro un kit, che vengono
       elencati al cliente ma pagati con la riga del kit. */
    rowPriceValue(row) {
      const p = Number(row?.price);
      return Number.isFinite(p) ? p : 0;
    },

    updateRowPrice(row, val, inputEl = null) {
      const grezzo = String(val ?? "")
        .trim()
        .replace(",", ".");
      // Campo svuotato: `Number("")` è 0, e una riga diventerebbe gratuita per
      // aver cancellato il prezzo senza riscriverlo. Si rimette quello di prima.
      if (!grezzo) {
        if (inputEl) inputEl.value = this.rowPriceValue(row);
        return;
      }
      const n = Number(grezzo);
      if (!Number.isFinite(n) || n < 0) {
        this.$toast.error("Il prezzo non può essere negativo.");
        if (inputEl) inputEl.value = this.rowPriceValue(row);
        return;
      }
      row.price = +n.toFixed(2);
      // [sc-48248] Il prezzo scritto qui è IL prezzo applicato. Va azzerato
      // anche `discountedPrice`, che l'API preferisce a `price`
      // (`resolveAppliedNet`): sulle righe che arrivano da una duplica è
      // valorizzato, e senza questa riga la modifica non arriverebbe a DB —
      // compreso il prezzo 0 dei prodotti dentro un kit.
      row.discountedPrice = null;
      // il binding :value non si aggiorna se il valore arrotondato coincide
      // con quello già in stato: riallineo il campo a mano
      if (inputEl && Number(inputEl.value) !== row.price) {
        inputEl.value = row.price;
      }
    },

    /* [sc-48248] Aliquota della riga. Le voci ammesse sono quelle di
       `ivaOptions`, le stesse del form di inserimento e dell'ENUM a DB. */
    updateRowIva(row, val) {
      const n = Number(val);
      const ammesse = this.ivaOptions.map((o) => o.value);
      if (!ammesse.includes(n)) {
        this.$toast.error("Aliquota IVA non ammessa.");
        return;
      }
      row.iva = n;
    },

    /* Articolo della riga, risolto dallo store (le righe portano solo l'id) */
    rowStockItem(row) {
      const itemId = row?.itemId ?? row?.id;
      if (row?.id && row?.category) return row;
      return this.getItemFromStore(itemId, this.categoryHintForRow(row));
    },

    /* Riga con scheda articolo incompleta: si evidenzia in tabella, così è
       chiaro cosa completare prima di confermare il preventivo. */
    isRowStockIncomplete(row) {
      return hasIncompleteStockData(this.rowStockItem(row));
    },

    rowStockWarning(row) {
      const item = this.rowStockItem(row);
      const missing = missingStockFields(item);
      if (!missing.length) return "";
      return `Scheda articolo incompleta (manca ${missing.join(
        ", "
      )}): completala prima di confermare il preventivo.`;
    },

    validateQuoteItemsBeforeSubmit() {
      const rows = this.formData.items || [];
      // nessuna riga a quantità 0: il preventivo non deve poter essere salvato
      const zeroQtyRow = rows.find((row) => this.qtyCell(row) < 1);
      if (zeroQtyRow) {
        const label = this.itemDisplay(zeroQtyRow)?.title || "articolo";
        this.errorMessage = `Quantità non valida per "${label}": inserisci almeno 1 o rimuovi l'articolo.`;
        this.$toast.error(this.errorMessage);
        return false;
      }
      return true;
    },

    isOrderQueued(item) {
      return !!item?.id && !!this.pendingOrderItems[item.id];
    },

    isOrderQueuedRow(row) {
      return !!row?.itemId && !!this.pendingOrderItems[row.itemId];
    },

    // Quantità da ordinare per una riga (scarto tra richiesta e giacenza)
    /* Quantità mancante espressa nell'unità della riga: per gli articoli a
       mq/ml le scatole da ordinare si traducono nei mq/ml corrispondenti
       (le scatole restano fra parentesi: è quello che si ordina davvero). */
    qtyToOrderLabel(row) {
      const boxes = this.qtyToOrder(row);
      const perBox = this.rowPerBox(row);
      const unit = this.rowQtyUnit(row);
      if (!perBox || unit === "pz") return `${boxes} pz`;
      const qty = formatDecimal(quantityFromBoxes(boxes, perBox));
      const isLinear = unit === "ml";
      const label =
        boxes === 1
          ? isLinear
            ? "confezione"
            : "scatola"
          : isLinear
          ? "confezioni"
          : "scatole";
      return `${qty} ${unit} (${boxes} ${label})`;
    },

    qtyToOrder(row) {
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      return this.orderQuantityForItem(item);
    },

    orderQuantityForItem(item) {
      if (!item?.id) return 1;

      const stock = this.warehouseCount(item);

      const row = (this.formData.items || []).find(
        (entry) => Number(entry?.itemId) === Number(item.id)
      );
      if (row) {
        const rowGroup = getCategoryGroup(item.category);
        const qty =
          rowGroup === "area" || rowGroup === "linear"
            ? Number(row.boxQuantity || row.quantity || 0)
            : Number(row.pieces || row.quantity || 0);
        if (qty > 0) {
          return stock > 0 ? Math.max(qty - stock, 1) : qty;
        }
      }

      if (this.newItem.itemId === item.id) {
        const g = getCategoryGroup(item.category);
        const qty =
          g === "area" || g === "linear"
            ? Number(this.newItem.boxQuantity || 0)
            : Number(this.newItem.pieces || 0);
        if (qty > 0) return stock > 0 ? Math.max(qty - stock, 1) : qty;
      }
      return 1;
    },

    buildPendingOrderNote(quoteId) {
      return `Ordine per preventivo #${quoteId}`;
    },

    async processPendingOrders(quoteId) {
      const itemIds = Object.keys(this.pendingOrderItems || {}).map(Number);
      if (!quoteId || !itemIds.length) return;

      const results = await Promise.allSettled(
        itemIds.map((itemId) =>
          this.createOrder({
            itemId,
            quantity: this.orderQuantityForItem(this.getItemFromStore(itemId)),
            notes: this.buildPendingOrderNote(quoteId, itemId),
          })
        )
      );

      const failed = results.filter((r) => r.status === "rejected");
      if (failed.length) {
        this.$toast.error(
          `${failed.length} carico/i merce non creato/i dopo il salvataggio del preventivo.`
        );
      } else {
        this.$toast.success(
          "Carichi merce collegati al preventivo creati con successo."
        );
      }
    },

    queueOrderFromQuoteItem(item) {
      if (!item?.id || this.isOrderQueued(item)) return;

      this.pendingOrderItems = {
        ...this.pendingOrderItems,
        [item.id]: true,
      };

      this.$toast.info(
        "Ordine messo in coda. Verrà creato al salvataggio del preventivo."
      );
    },

    unqueueOrderFromQuoteItem(item) {
      if (!item?.id || !this.isOrderQueued(item)) return;

      const next = { ...this.pendingOrderItems };
      delete next[item.id];
      this.pendingOrderItems = next;

      if (this.newItem.itemId === item.id) this.orderNote = "";

      this.$toast.info("Ordine rimosso dalla coda.");
    },

    toggleItemsList() {
      this.panelVisible = !this.panelVisible;
    },

    startSearch(type) {
      this.activeSearch = type; // 'client' o 'item'
      this.showDropdown = true;
      this.selectedIndex = -1;
      // azzera solo il campo “attivo”
      if (type === "client") this.searchQueryClient = "";
      if (type === "item") this.searchQueryItem = "";
    },

    handleKey(event) {
      if (!this.showDropdown) return;

      // Quale array devo navigare?
      let list;
      if (this.activeSearch === "client") {
        list = this.filteredClients;
      } else if (this.activeSearch === "item") {
        list = this.filteredItems;
      } else {
        list = [];
      }

      // ========== freccia giù ==========
      if (event.key === "ArrowDown") {
        this.selectedIndex =
          this.selectedIndex < list.length - 1 ? this.selectedIndex + 1 : 0;
        event.preventDefault();

        // ========== freccia su ==========
      } else if (event.key === "ArrowUp") {
        this.selectedIndex =
          this.selectedIndex > 0 ? this.selectedIndex - 1 : list.length - 1;
        event.preventDefault();

        // ========== ENTER ==========
      } else if (event.key === "Enter") {
        if (this.selectedIndex >= 0 && this.selectedIndex < list.length) {
          const chosen = list[this.selectedIndex];

          if (this.activeSearch === "client") {
            // selezione cliente
            this.formData.clientId = chosen.id;
            this.searchQueryClient = chosen.clientName;
          } else if (this.activeSearch === "item") {
            // selezione articolo
            this.newItem.itemId = chosen.id;
            this.searchQueryItem = chosen.itemName
              ? `${chosen.itemName} ${chosen.measureDesc}`
              : `${chosen.subBrand} ${chosen.fixtureType || ""} ${
                  chosen.fixturePosition || ""
                }`;
            // Prezzo di listino NETTO (IVA esclusa), invariato al cambio IVA.
            this.newItem.price = Number(chosen.price) || 0;
            // memorizza l'oggetto articolo completo
            // this.selectedItemById[chosen.id] = chosen;
            this.selectedByKey[KEY.STOCK(chosen.id)] = chosen;
          }
          this.showDropdown = false;
          this.selectedIndex = -1;
        }
        event.preventDefault();
      }
    },

    selectClient(client) {
      this.formData.clientId = client.id;
      this.searchQueryClient = client.clientName;
      this.hideDropdown();
    },
    selectItem(item) {
      this.newItem.itemId = item.id;
      this.orderNote = "";
      this.searchQueryItem = this.itemSearchLabel(item);
      // const item =
      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // Prezzo di listino NETTO (IVA esclusa), invariato al cambio IVA.
      this.newItem.price = Number(item.price) || 0;
      // Prezzo scontato: inizialmente vuoto (l'operatore lo digita se serve).
      this.newItem.discountedPrice = "";
      // il campo mq deve riflettere la quantità dell'articolo appena scelto
      this.syncMqInputFromBoxes();
      this.hideDropdown();
    },

    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
        this.selectedIndex = -1;
        this.activeSearch = null;
      }, 300);
    },

    nameForDisplay(src) {
      return this.itemDisplayFromObj(src || {}).title || "Sconosciuto";
    },

    /**
     * Gestisce la selezione di un cliente dal dropdown.
     * Chiude il dropdown e aggiorna la searchQueryClient con il nome del cliente selezionato.
     */
    handleClientSelection() {
      this.showDropdown = false;
      this.searchQueryClient = this.getClientName(this.formData.clientId);
    },

    /* Numero opzionale non negativo: preserva lo zero (riga gratuita). Ritorna
       null per assente/vuoto/non numerico o negativo. */
    optionalNonNegativeNumber(value) {
      if (value === "" || value === null || value === undefined) return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
    },

    async onSelectItem() {
      // 1) hide dropdown
      this.hideDropdown();
      // console.log("newitem", this.newItem);
      // 2) trova l'item selezionato
      const item = this.getItemFromStore(this.newItem.itemId, "STOCK");
      if (!item.id) return;

      // memorizza l'oggetto articolo completo
      // this.selectedItemById[item.id] = item;
      this.selectedByKey[KEY.STOCK(item.id)] = item;
      // 3) aggiorna la searchQuery per mostrare il nome selezionato
      this.searchQueryItem = item.itemName
        ? `${item.itemName} ${item.measureDesc}`
        : `${item.subBrand} ${item.fixtureType || ""} ${
            item.fixturePosition || ""
          }`;

      // 4) popola il prezzo di listino NETTO (IVA esclusa)
      this.newItem.price = Number(item.price) || 0;
    },

    addItem() {
      this.errorMessage = "";
      this.successMessage = "";

      const isAreaOrLinear =
        this.selectedItemGroup === "area" ||
        this.selectedItemGroup === "linear";
      const selected = this.selectedItem;

      const qty = isAreaOrLinear
        ? Number(this.newItem.boxQuantity || 0)
        : Number(this.newItem.pieces || 0);

      if (!this.newItem.itemId || qty <= 0 || !this.newItem.price) {
        this.errorMessage =
          "Compila tutti i campi prima di aggiungere un articolo.";
        this.$toast.error(this.errorMessage);
        return;
      }

      const fullObj = this.selectedItem;
      if (fullObj?.id) {
        this.selectedByKey[KEY.STOCK(fullObj.id)] = fullObj;
      }

      // Prezzo NETTO applicato: scontato se valorizzato (zero incluso),
      // altrimenti il listino netto. Nessuno sconto inviato al backend.
      const personalized = this.optionalNonNegativeNumber(
        this.newItem.discountedPrice
      );
      const appliedNet =
        personalized !== null ? personalized : Number(this.newItem.price) || 0;

      const existing = this.formData.items.find(
        (r) => r.itemId === this.newItem.itemId && r.iva === this.newItem.iva
      );

      if (existing) {
        if (isAreaOrLinear) {
          existing.boxQuantity = this.newItem.boxQuantity;
          existing.pieces = 0;
          existing.mqQuantity = this.typedMqQuantity();
        } else {
          existing.pieces = this.newItem.pieces;
        }
        existing.price = appliedNet;
        existing.iva = this.newItem.iva;

        this.$nextTick(() => {
          this.successMessage = "Quantità aggiornata per l'articolo esistente.";
          this.$toast.success(this.successMessage);
        });
        return; // niente push()
      }

      this.formData.items.push({
        itemId: this.newItem.itemId ?? null,
        boxQuantity: this.newItem.boxQuantity,
        pieces: this.newItem.pieces,
        // mq/ml scritti dall'operatore: base di calcolo dell'importo
        mqQuantity: this.typedMqQuantity(),
        // prezzo netto applicato (personalizzato se valorizzato, altrimenti listino)
        price: appliedNet,
        iva: this.newItem.iva,
        category: selected.category || "STOCK",
      });
      // console.log("formData.items: ", this.formData.items);
      this.$nextTick(() => {
        this.successMessage = "Articolo aggiunto con successo.";
        this.$toast.success(this.successMessage);
      });
      this.newItem = {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        discountedPrice: "",
        iva: 0,
        category: "",
      };
      this.searchQueryItem = "";
      this.showDropdown = false;
    },

    removeItem(index) {
      this.formData.items.splice(index, 1);
    },

    saveToLocalStorage(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },

    loadFromLocalStorage(key) {
      const savedData = localStorage.getItem(key);
      if (savedData) {
        return JSON.parse(savedData);
      }
      return null;
    },

    cap(w) {
      const s = (w || "").toString().trim();
      return s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : "";
    },

    itemDisplay(row) {
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      return this.itemDisplayFromObj(it);
    },

    // Usa la stessa logica di itemDisplay ma partendo da id+categoria
    itemDisplayById(id, categoryHint) {
      const it = this.getItemFromStore(id, categoryHint) || {};
      // riusa la parte di formattazione dentro itemDisplay:
      // copiamo la stessa logica in una funzione dedicata
      return this.itemDisplayFromObj(it);
    },

    // Estrae { title, meta } da un oggetto item già risolto
    itemDisplayFromObj(it = {}) {
      const Cap = (s) =>
        (s || "")
          .toString()
          .trim()
          .replace(/^\w/, (c) => c.toUpperCase());

      // ---- GRUPPO AREA (piastrelle, rivestimenti, parquet, laminati, decking) ----
      if (getCategoryGroup(it.category) === "area") {
        const title = it.itemName || "Articolo";
        const dim =
          it.measureDesc ||
          it.formatLabel ||
          (it.widthCm && it.heightCm
            ? `${it.widthCm}×${it.heightCm} cm`
            : null);
        const meta =
          [
            dim,
            it.surface,
            it.thicknessMm ? `${it.thicknessMm}mm` : null,
            it.color,
          ]
            .filter(Boolean)
            .join(" · ") ||
          it.category ||
          "";
        return { title: title || "Articolo", meta };
      }

      // ---- ALTRI GRUPPI ----
      const title =
        it.itemName ||
        [it.brand, it.subBrand].filter(Boolean).join(" \u2192 ").trim() ||
        "Articolo";

      const T = Cap(it.fixtureType || "");
      const P =
        it.fixturePosition === "terra"
          ? "a terra"
          : Cap(it.fixturePosition || "");

      // se ho info di tipo/posizione le mostro; altrimenti fallback alla subCategory (es. "Sanitari"/"Altro")
      const metaParts = [T, P].filter(Boolean);
      const meta = metaParts.length
        ? metaParts.join(" ")
        : Cap(it.subCategory || "");

      return { title, meta };
    },

    // ⚠️ Back-compat: ora usa la nuova formattazione e restituisce solo il titolo
    getItemName(id, categoryHint) {
      return this.itemDisplayById(id, categoryHint).title;
    },

    getClientName(clientId) {
      const client = this.clients.find((c) => c.id === clientId);
      return client ? client.clientName : "Sconosciuto";
    },

    formatIva(iva) {
      const percentageSymbol = "%";
      return `${iva} ${percentageSymbol}`;
    },

    formatPrice(price) {
      const currencySymbol = "€"; // Cambia in "$" per il dollaro
      return `${currencySymbol} ${formatDecimal(price)}`;
    },

    unitForRow(row) {
      const it =
        this.getItemFromStore(row.itemId, this.categoryHintForRow(row)) || {};
      if (
        String(row?.itemName || it?.itemName || "")
          .toLowerCase()
          .includes("battiscopa")
      )
        return "€/mL";
      const group = getCategoryGroup(it.category);
      if (group === "area") return "€/mq";
      if (group === "linear") return "€/ml";
      return "€/pz";
    },

    mqForRow(row) {
      // console.log("row", row);
      const item = this.getItemFromStore(
        row.itemId,
        this.categoryHintForRow(row)
      );
      // console.log("mqForRow item: ", item);
      const sqmPerBox = Number(item.sqmPerBox) || 0;
      const boxes = Number(row.boxQuantity) || 0;
      const total = sqmPerBox * boxes;
      return total ? total.toFixed(2) : "";
    },

    resetNewItem() {
      return {
        itemId: null,
        boxQuantity: 0,
        pieces: 0,
        price: "",
        discountedPrice: "",
        category: "",
        quantity: 0,
        iva: 0,
      };
    },

    async onCreateQuoteAndGeneratePdf({ generatePdf = true } = {}) {
      this.errorMessage = "";
      this.successMessage = "";

      // 0) Validazioni minime (indirizzo facoltativo; modalità obbligatoria)
      if (this.formData.items.length === 0) {
        this.errorMessage = "Aggiungi almeno un articolo prima di salvare";
        this.$toast.error(this.errorMessage);
        return;
      }
      if (!this.formData.deliveryType) {
        this.errorMessage =
          "Seleziona la modalità: consegna o ritiro, prima di salvare";
        this.$toast.error(this.errorMessage);
        return;
      }

      try {
        // 1) Se hai un articolo parzialmente compilato nei campi input, aggiungilo prima del salvataggio
        if (
          this.newItem.itemId &&
          (this.newItem.boxQuantity || this.newItem.pieces)
        ) {
          this.formData.items.push({
            ...this.newItem,
            mqQuantity: this.typedMqQuantity(),
          });
        }

        if (!this.validateQuoteItemsBeforeSubmit()) return;

        // 2) Salvataggio preventivo
        const payload = {
          ...this.formData,
          technical_queries: (this.formData.technical_queries || "").trim(),
        };

        // [sc-48258] I flag li manda solo la rotta degli ordini: il server li
        // ignora comunque senza `asOrder`, ma non vale la pena spedirli.
        if (this.asOrder) {
          payload.asOrder = true;
          payload.markPaid = this.ordineSaldato;
          payload.markDelivered = this.ordineSaldato && this.ordineConsegnato;
          payload.confirmDuplicate = this.ordineDuplicatoConfermato;
        }

        if (payload.date && payload.date.length === 10) {
          payload.date = new Date(payload.date + "T00:00:00").toISOString();
        }

        const sanitize = (s) => (s || "").replace(/\p{C}+/gu, "");
        payload.technical_queries = sanitize(payload.technical_queries);
        // console.log("Creating quote with payload:", payload);
        const response = await this.$store.dispatch("createQuote", payload);
        this.response = response; // mantengo per compatibilità col tuo codice
        // console.log("Create quote response:", response);

        if (response?.status !== 200 && response?.status !== 201) {
          // ⬇️ ramo 409
          if (
            response?.status === 409 &&
            response?.data.code === "QUOTE_DUPLICATE"
          ) {
            const d = response?.data || {};
            const details = (typeof d.details === "object" && d.details) || {};
            const id =
              details.quoteId ??
              details.id ??
              details.quote?.id ??
              d.quoteId ??
              d.id ??
              null;

            const address =
              details.address ?? this.formData?.location?.address ?? null;

            this.$toast.error(
              d.message ||
                d.details ||
                "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso..."
            );
            this.openDuplicateModal(id, address, details.isOrder === true);
            return;
          }

          // ...altri errori
          this.errorMessage =
            response.data?.details ||
            response.data?.message ||
            (this.asOrder
              ? "Impossibile creare l'ordine."
              : "Impossibile creare il preventivo.");
          this.$toast.error(this.errorMessage);
          this.successMessage = "";
          return;
        }

        // 3) Messaggio OK salvataggio
        this.successMessage =
          response.data?.message ||
          (this.asOrder
            ? "Ordine creato con successo!"
            : "Preventivo creato con successo!");
        this.$toast.success(this.successMessage);

        const quoteWrap = response.data?.quote || {};
        const createdQuoteId = Number(quoteWrap?.newQuote?.id || 0);
        await this.processPendingOrders(createdQuoteId);

        // 4) Se richiesto, genera + carica + scarica PDF
        if (generatePdf) {
          const nq = quoteWrap.newQuote;
          const quoteForPdf = {
            ...nq,
            totalPrice: quoteWrap.totalPrice ?? nq?.totalPrice,
            Client: {
              clientName: nq.clientName,
              phoneNumber: nq.phoneNumber,
              pec: nq.pec,
              email: nq.email,
              vatNumber: nq.vatNumber,
              taxCode: nq.taxCode,
              companyName: nq.companyName,
              legalHeadquarters: nq.legalHeadquarters,
            },
          };
          await generateQuotePdf({
            quote: quoteForPdf,
            // [sc-48258] Titolo, totale e nome file del PDF seguono la natura
            // del documento: questo è nato ordine, non preventivo.
            isOrder: this.asOrder,
            toast: this.$toast,
            uploadQuoteDocument: (payload) =>
              this.$store.dispatch("uploadQuoteDocument", payload),
            mqOverrides: this.mqOverridesForPdf(),
          });
        }

        // 5) Reset campi (comuni)
        this.formData = {
          location: {
            name: "",
            address: "",
            placeId: "",
            latitude: "",
            longitude: "",
          },
          technical_queries: "",
          clientId: "",
          items: [],
          date: "",
          payment_method: "",
          deliveryType: "",
        };

        this.newItem = this.resetNewItem();
        this.searchQueryItem = "";
        this.ordineSaldato = false;
        this.ordineConsegnato = false;
        this.ordineDuplicatoConfermato = false;

        this.resetLocation();

        // 6) Redirect: ognuno torna al suo elenco
        setTimeout(() => {
          this.navigationConfirmed = true;
          this.$router.push({ name: this.asOrder ? "ordini" : "quotes" });
          this.errorMessage = "";
          this.successMessage = "";
        }, 4000);
      } catch (error) {
        const resp = error?.response;

        // ⬇️ ramo 409
        if (resp?.status === 409 && resp?.data?.code === "QUOTE_DUPLICATE") {
          const d = resp?.data || {}; // usa quello che hai a disposizione
          const details = (typeof d.details === "object" && d.details) || {};
          const id =
            details.quoteId ??
            details.id ??
            details.quote?.id ??
            d.quoteId ??
            d.id ??
            null;

          const address =
            details.address ?? this.formData?.location?.address ?? null;

          this.$toast.error(
            d.message ||
              d.details ||
              "Esiste già un preventivo per questo cliente allo stesso indirizzo in corso..."
          );
          this.openDuplicateModal(id, address, details.isOrder === true);
          return;
        }

        // ...altri errori
        this.errorMessage =
          resp?.data?.message ||
          resp?.data?.details ||
          resp?.data?.error ||
          "Errore durante la creazione del preventivo.";
        this.$toast.error(this.errorMessage);
        this.successMessage = "";
      }
    },

    resetLocation() {
      this.formData.location = {
        name: "",
        address: "",
        placeId: "",
        latitude: "",
        longitude: "",
      };
    },

    handlePlaceChange() {
      // Puoi gestire azioni aggiuntive dopo il cambio del luogo
    },

    // Prima ricerca (nuova query): pagina 1, svuota subito i risultati e reset
    // su 404/errore. `reqId` progressivo: le risposte obsolete (digitazione
    // rapida o cambio pagina in volo) vengono ignorate.
    fetchItems(q) {
      const query = (q || "").trim();
      const reqId = ++this.itemsRequestId;
      this.itemsSearchQuery = query;
      this.itemsPage = 1;
      this.itemsRequestedPage = null;
      this.itemsTotalPages = 1;
      this.itemsTotalItems = null;
      this.itemsTotalIsCapped = false;
      // I risultati della ricerca precedente non devono restare visibili né
      // selezionabili durante il caricamento della nuova query.
      this.filteredItems = [];
      this.requestItemsPage(query, 1, reqId, true);
    },
    // Cambio pagina (stessa query): imposta subito la pagina richiesta
    // (pending), poi la carica. Un click su un'altra pagina mentre una è in
    // volo la "supera" (nuovo reqId); i doppioni verso la pagina già richiesta o
    // già caricata sono ignorati. I risultati sostituiscono, non concatenano.
    onItemPageChange(page) {
      const target = Number(page);
      if (!Number.isInteger(target)) return;
      if (target < 1 || target > this.itemsTotalPages) return;
      const active =
        this.itemsRequestedPage != null
          ? this.itemsRequestedPage
          : this.itemsPage;
      if (target === active) return; // niente richieste duplicate
      this.itemsRequestedPage = target;
      const reqId = ++this.itemsRequestId;
      this.requestItemsPage(this.itemsSearchQuery, target, reqId, false);
    },
    // GET condivisa. `isFirstSearch` distingue la gestione errori. Una risposta
    // obsoleta (reqId superato) esce subito senza toccare risultati, pagina o
    // stato loading/pending.
    requestItemsPage(query, page, reqId, isFirstSearch) {
      this.itemsLoading = true;
      axiosInstance
        .get("/item/get-all", { params: { page, limit: 10, search: query } })
        .then(({ data }) => {
          if (reqId !== this.itemsRequestId) return; // risposta obsoleta
          this.filteredItems = data.results || [];
          const p = data.pagination || {};
          this.itemsPage = p.currentPage || page;
          this.itemsTotalPages = p.totalPages || 1;
          this.itemsTotalItems = p.totalItems ?? null;
          this.itemsTotalIsCapped = Boolean(p.totalIsCapped);
          this.itemsRequestedPage = null; // pagina caricata: pending azzerato
        })
        .catch((err) => {
          if (reqId !== this.itemsRequestId) return; // risposta obsoleta
          const is404 = err?.response?.status === 404;
          if (!is404) console.error(err);
          if (isFirstSearch) {
            // Nessun risultato / errore in prima ricerca: lista vuota, pagina 1.
            this.filteredItems = [];
            this.itemsPage = 1;
            this.itemsTotalPages = 1;
            this.itemsTotalItems = is404 ? 0 : null;
            this.itemsTotalIsCapped = false;
          }
          // Cambio pagina fallito: si mantengono risultati e itemsPage caricati;
          // si azzera solo la pagina richiesta e si riabilitano i controlli.
          this.itemsRequestedPage = null;
        })
        .finally(() => {
          if (reqId === this.itemsRequestId) this.itemsLoading = false;
        });
    },
    // --- pulizia selezione articolo di magazzino ---
    clearItemSelection() {
      const iva = this.newItem.iva ?? 22; // preserva l'IVA scelta (anche 0%)
      Object.assign(this.newItem, this.resetNewItem(), { iva });
      this.searchQueryItem = "";
      this.orderNote = "";
    },

    // Apertura modale "Crea articolo".
    openCreateItemModal() {
      console.log("openCreateItemModal"); // DEBUG temporaneo
      this.showCreateItemModal = true;
    },

    // Articolo creato dalla modale: lo rende disponibile nella ricerca e lo
    // auto-seleziona riusando la logica esistente selectItem().
    async onItemCreated({ item, itemCode, message }) {
      let createdItem = item;

      // Fallback robusto: se la response non è completa, rileggo l'articolo
      // con lo stesso endpoint/param (search) usato dalla ricerca del preventivo.
      if (!createdItem || createdItem.id == null || createdItem.price == null) {
        const { data } = await axiosInstance.get("/item/get-all", {
          params: { page: 1, limit: 10, search: itemCode },
        });
        const results = data?.results || [];
        createdItem =
          results.find(
            (it) => it.itemCode === itemCode || it.item_code === itemCode
          ) ||
          results[0] ||
          createdItem;
      }

      if (!createdItem?.id) {
        this.$toast.error("Articolo creato ma non recuperabile.");
        return;
      }

      if (!this.filteredItems.some((it) => it.id === createdItem.id)) {
        this.filteredItems = [createdItem, ...this.filteredItems];
      }

      this.selectItem(createdItem);
      this.showCreateItemModal = false;
      this.$toast.success(message || "Articolo creato e selezionato");
    },
  },

  watch: {
    // 🔄 Ricerca + pulizia selezione se l'utente svuota il campo
    searchQueryItem(newQ, oldQ) {
      if (oldQ && !newQ.trim() && this.newItem.itemId)
        this.clearItemSelection();
      this.debouncedFetchItems(newQ.trim());
    },

    /* Deselezione articolo (addItem, clearItemSelection, reset form): svuota
       anche il campo mq */
    "newItem.itemId"(id) {
      if (!id) this.mqInput = "";
    },

    /* mq/ml digitati -> scatole intere del preventivo (arrotondamento per
       eccesso). Il campo resta com'è stato scritto: nessuna riscrittura. */
    mqInput(v) {
      if (!this.showMqField) return;
      const perBox = perBoxOrFallback(this.mqPerBox);
      const boxes = boxesFromQuantity(v, perBox);
      this.newItem.boxQuantity = boxes;
      const ppb = this.selectedItem.piecesPerBox || 1;
      this.newItem.pieces = this.selectedItemGroup === "area" ? boxes * ppb : 0;
    },

    // aggiornamento riga esistente (come avevi)
    newItem: {
      deep: true,
      handler(nv) {
        if (!nv) return;

        // Trova la riga esistente in base all'id correntemente selezionato
        const id = nv.itemId;
        // console.log({ nv: nv, id: id });
        if (!id) return;

        const key = "itemId";
        // console.log("key", key);
        // console.log("formdata", this.formData.items);
        const row = this.formData.items.find((x) => x[key] === id);
        // console.log("row", row);

        // Se non è stata ancora aggiunta con addItem(), non toccare nulla
        if (!row) return;

        const group = getCategoryGroup(this.selectedItem?.category);
        const isBoxBased = group === "area" || group === "linear";
        const qty = isBoxBased
          ? Number(nv.boxQuantity) || 0
          : Number(nv.pieces) || 0;
        // qty 0 = articolo appena riselezionato nel form (campo quantità ancora
        // vuoto): non azzerare la riga già presente in tabella
        if (qty > 0) {
          row.boxQuantity = isBoxBased ? qty : 0;
          row.pieces = isBoxBased ? 0 : qty;
          if (isBoxBased) row.mqQuantity = this.typedMqQuantity();
        }
        row.price = nv.price;
        row.iva = nv.iva;
        // console.log("row after update", row);
      },
    },
    //       this.selectedItem.category === "piastrelle"
    //         ? nv.boxQuantity
    //         : this.selectedItem.subCategory === "piastrelle"
    //         ? nv.sqmQuantity
    //         : nv.pieces || 0;
    //     row.quantity = qty;
    //     row.boxQuantity = nv.boxQuantity;
    //     row.pieces = nv.pieces;
    //     row.price = nv.price;
    //     row.iva = nv.iva;
    //   },
    //   deep: true,
    // },

    // [sc-48258] Togliendo il saldo cade anche la consegna: il server rifiuta
    // un ordine consegnato e non saldato, e lasciare la spunta accesa farebbe
    // fallire il salvataggio senza che si capisca perché.
    ordineSaldato(v) {
      if (!v) this.ordineConsegnato = false;
    },
    showDuplicateModal(v) {
      if (
        v &&
        this.lastDuplicateQuoteInfo &&
        this.lastDuplicateQuoteInfo.quoteId
      ) {
        this.loadDuplicateQuote();
      }
    },
    lastDuplicateQuoteInfo: {
      deep: true,
      handler(nv) {
        if (this.showDuplicateModal && nv && nv.quoteId) {
          this.loadDuplicateQuote();
        }
      },
    },
  },

  mounted() {
    this.panelVisible = window.innerWidth >= 768;
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    // [sc-48248] Arrivo dalla duplica: la pagina è la stessa del nuovo
    // preventivo, con gli articoli già dentro.
    const duplicaDa = this.$route.query?.duplicaDa;
    if (duplicaDa) this.caricaDaDuplicazione(duplicaDa);
  },
};
</script>

<style src="@/css/CreateQuotePage.css"></style>
